// import React, { useState, useRef, useEffect } from "react";
// import axios from "axios";
// import { Document, Page, Text, View, StyleSheet, Image, pdf } from '@react-pdf/renderer';

// // Types
// interface Company {
//   id: number;
//   company_name: string;
//   address: string | null;
//   password: string;
//   pancard: string;
//   city: string | null;
//   state: string | null;
//   country: string | null;
//   gst_number: string | null;
//   gst_uin: string | null;
//   code: string | null;
//   cin: string | null;
//   email: string | null;
//   created_at: string;
//   updated_at: string;
//   HSN_SAC: string;
//   GST_SLAB: string | null;
//   signature: string;
//   prefix: string;
//   postfix: string;
//   separatorsign: string;
// }
// interface Sender {
//   id: number;
//   name: string;
//   email: string;
//   number: string;
//   password: string;
//   role: string;
//   deletedUser: number;
//   createdAt: string;
//   updatedAt: string;
//   address: string | null;
//   city: string | null;
//   state: string | null;
//   pincode: string | null;
//   gst_number: string | null;
//   pan_number: string | null;
//   aadhaar_number: string | null;
//   license_number: string | null;
//   bank_name: string | null;
//   bank_account_number: string | null;
//   bank_ifsc: string | null;
//   account_holder_name: string | null;
//   govt_id_type: string | null;
//   govt_id_number: string | null;
//   govt_id_document_url: string | null;
//   gst_document_url: string | null;
//   bank_document_url: string | null;
//   profile_status: string;
// }
// interface Receiver {
//   id: number;
//   name: string;
//   email: string;
//   number: string;
//   password: string;
//   role: string;
//   deletedUser: number;
//   createdAt: string;
//   updatedAt: string;
//   address: string | null;
//   city: string | null;
//   state: string | null;
//   pincode: string | null;
//   gst_number: string | null;
//   pan_number: string | null;
//   aadhaar_number: string | null;
//   license_number: string | null;
//   bank_name: string | null;
//   bank_account_number: string | null;
//   bank_ifsc: string | null;
//   account_holder_name: string | null;
//   govt_id_type: string | null;
//   govt_id_number: string | null;
//   govt_id_document_url: string | null;
//   gst_document_url: string | null;
//   bank_document_url: string | null;
//   profile_status: string;
// }
// interface Vehicle {
//   id: number;
//   vehicle_number: string;
//   transporter_id?: number | null;
//   driver_id: number;
//   registration_number: string;
//   vehicle_type: string | null;
//   capacity_kg: number;
//   is_available?: boolean | null;
//   capacity?: number | null;
//   fuel_type?: string | null;
//   fitness_expiry?: string | null;
//   insurance_expiry?: string | null;
//   color?: string | null;
// }
// interface Driver {
//   id: number;
//   name: string;
//   phone: string;
//   user_id?: number | null;
//   transporter_id?: number | null;
//   license_number: string;
//   license_expiry: string;
//   current_vehicle_id?: number | null;
//   status?: string | null;
//   aadhar?: string | null;
//   address?: string | null;
//   city?: string | null;
//   state?: string | null;
//   upi_id?: string | null;
//   bank_account_name?: string | null;
//   bank_account_number?: string | null;
//   bank_ifsc?: string | null;
//   bank_name?: string | null;
// }
// interface Transporter {
//   id: number;
//   user_id?: number | null;
//   company_name: string;
//   fleet_size?: number | null;
//   license_number: string;
//   contact_email?: string | null;
//   contact_phone?: string | null;
//   gst_number?: string | null;
//   address?: string | null;
//   city?: string | null;
//   state?: string | null;
//   pincode?: string | null;
//   vehicle: Vehicle;
//   driver: Driver;
// }
// interface ConsignmentDetails {
//   origin: string;
//   destination: string;
//   description: string;
// }
// interface Item {
//   name: string;
//   qty: string;
//   weight: string;
//   ratePerQtl: string;
// }
// interface SubmittedData {
//   company: Company | null;
//   sender: Sender | null;
//   receiver: Receiver | null;
//   singletransporter: Transporter | null;
//   consignmentDetails: ConsignmentDetails;
//   items: Item[];
//   paymentType: string;
//   date: string;
//   invoiceId: string;
//   paymentPayableConsignorId?: number;
//   subject?: string;
//   ewaybillno?: string;
// }

// type PaymentParty = "sender" | "receiver";

// const steps = [
//   "Transporter",
//   "Company",
//   "Sender",
//   "Receiver",
//   "Details",
//   "Items",
//   "Payment",
//   "Invoice",
// ];

// function generateInvoiceId(origin: string, destination: string, vehicle_number: string | undefined, dateString: string) {
//   try {
//     let id =
//       (origin?.substring(0, 2) || "OR").toUpperCase() +
//       (destination?.substring(0, 2) || "DE").toUpperCase() +
//       (vehicle_number ? vehicle_number.slice(-4) : "0000") +
//       dateString.replace(/-/g, "");
//     return id;
//   } catch {
//     return "LRNO202404";
//   }
// }

// interface InvoicePreviewPanelProps {
//   company: Company | null;
//   sender: Sender | null;
//   receiver: Receiver | null;
//   transporter: Transporter | null;
//   selectedTransport: any;
//   selectedDate: any;
//   selectedDriver: any;
//   selectedVehicle: any;
//   consignmentDetails: ConsignmentDetails;
//   items: Item[];
//   paymentType: string;
//   step: number;
//   submittedData: SubmittedData | null;
//   subject?: string;
//   invoiceNumber?: string;
// }

// function totalFromItems(items: any[]): string {
//   const total = items.reduce((sum, item) => {
//     const qty = parseFloat(item.qty);
//     const rate = parseFloat(item.ratePerQtl);
//     return sum + (isNaN(qty) || isNaN(rate) ? 0 : qty * rate);
//   }, 0);
//   return total > 0 ? `₹${total.toLocaleString("en-IN")}` : "";
// }

// function InvoicePreviewPanel({
//   company,
//   sender,
//   receiver,
//   transporter,
//   selectedDate,
//   selectedTransport,
//   selectedDriver,
//   selectedVehicle,
//   consignmentDetails,
//   items,
//   paymentType,
//   step,
//   submittedData,
//   subject,
//   invoiceNumber,
// }: InvoicePreviewPanelProps) {
//   const formatEntity = (entity: any) => {
//     if (!entity) return "—";
//     if (typeof entity === "string") return entity;
//     if (entity.company_name) return entity.company_name;
//     if (entity.address) return entity.address;
//     return JSON.stringify(entity);
//   };
//   const hasContent =
//     !!company ||
//     !!sender ||
//     !!receiver ||
//     !!transporter ||
//     (!!consignmentDetails &&
//       (consignmentDetails.origin ||
//         consignmentDetails.destination ||
//         consignmentDetails.description));
//   if (!hasContent) {
//     return (
//       <div className="bg-white text-black font-sans text-xs border-2 border-black max-w-3xl mx-auto h-full flex flex-col justify-center items-center py-10">
//         <p className="text-xs font-black text-red-600 uppercase tracking-wide">Live Preview</p>
//         <p className="text-[11px] text-black mt-1 font-medium">Updates as you fill in</p>
//         <p className="text-[13px] text-black/50 italic mt-6">Start filling the form to see a preview here.</p>
//       </div>
//     );
//   }
//   const det = consignmentDetails ?? {};
//   const safeItems = Array.isArray(items) ? items.filter((i) => i && typeof i === "object" && i.name) : [];
//   let paymentLabel: string;
//   switch (paymentType) {
//     case "paid": paymentLabel = "Paid"; break;
//     case "to_pay": paymentLabel = "To Pay"; break;
//     case "credit": paymentLabel = "Credit"; break;
//     default: paymentLabel = "—";
//   }

//   // Use manual invoice number if provided, else submitted invoiceId
//   const displayLrNo = submittedData?.invoiceId || invoiceNumber?.trim() || "";

//   return (
//     <div className="bg-white text-black font-sans text-xs border-2 border-black max-w-3xl mx-auto">
//       <div className="text-center border-b-2 border-black py-2 px-2">
//         <h1 className="text-2xl font-black tracking-widest text-black">{company?.company_name || "COMPANY NAME"}</h1>
//         <p className="text-[10px] mt-0.5">{company?.address || "COMPANY ADDRESS"}</p>
//       </div>
//       <div className="flex border-b border-black">
//         <div className="flex-1 px-2 py-1 border-r border-black">
//           <span className="text-[9px] text-gray-500 uppercase block">GST Enrol No:</span>
//           <span className="font-bold text-[11px]">{company?.gst_number}</span>
//         </div>
//         <div className="flex-1 px-2 py-1 border-r border-black">
//           <span className="text-[9px] text-gray-500 uppercase block">PAN No.</span>
//           <span className="font-bold text-[11px]">{company?.pancard}</span>
//         </div>
//         <div className="px-2 py-1 flex items-end justify-end min-w-[120px]">
//           <span className="text-[9px] text-gray-500">AT OWNERS RISK</span>
//         </div>
//       </div>
//       <div className="px-2 py-0.5 text-[10px] border-b border-black">Email Id. - {company?.email}</div>
//       <div className="bg-gray-200 text-center text-[9px] uppercase tracking-widest py-0.5 border-b border-black">
//         {subject || "Subject to Kishangarh Jurisdiction"}
//       </div>
//       <div className="flex border-b border-black">
//         <div className="flex-1 px-2 py-1.5 border-r border-black">
//           <div className="text-[9px] text-gray-500 uppercase mb-0.5">Consignor's / Supplier's Name &amp; Address</div>
//           <div className="text-sm font-black">{sender?.name}</div>
//           <div className="mt-0.5 text-[11px] text-gray-600">{sender?.address}</div>
//         </div>
//         <div className="w-64 px-2 py-1.5 text-[11px] space-y-0.5">
//           {displayLrNo && (
//             <div className="flex items-center gap-1">
//               <span className="font-bold whitespace-nowrap">GR NO.:-</span>
//               <span>{displayLrNo}</span>
//             </div>
//           )}
//           <div className="flex items-center gap-1">
//             <span className="font-bold whitespace-nowrap">DATED :-</span>
//             <span>{selectedDate}</span>
//           </div>
//           <div className="flex items-center gap-1">
//             <span className="font-bold whitespace-nowrap uppercase">{selectedVehicle?.vehicle_type ? selectedVehicle?.vehicle_type : "DEFAULT"} NO.:-</span>
//             <span>{selectedVehicle?.vehicle_number ? selectedVehicle?.vehicle_number : "DEFAULT"}</span>
//           </div>
//           <div className="flex items-center gap-1">
//             <span className="font-bold whitespace-nowrap">FROM :-</span>
//             <span>{det.origin || "—"}</span>
//           </div>
//           <div className="flex items-center gap-1">
//             <span className="font-bold whitespace-nowrap">To:-</span>
//             <span>{det.destination || "—"}</span>
//           </div>
//         </div>
//       </div>
//       <div className="flex border-b border-black">
//         <div className="flex-1 px-2 py-1.5 border-r border-black">
//           <div className="text-[9px] text-gray-500 uppercase mb-0.5">Consignee's / Recipient's Name &amp; Address</div>
//           <div className="text-sm font-black">{receiver?.name}</div>
//           <div className="mt-0.5 text-[11px] text-gray-600">{receiver?.address || ""}</div>
//         </div>
//         <div className="w-64 flex items-center justify-center px-3 py-2">
//           <p className="text-red-600 font-black text-sm text-center leading-snug">NOTE- NO CASH ONLY CHEQUE OR POD</p>
//         </div>
//       </div>
//       <table className="w-full border-collapse text-[11px]">
//         <thead>
//           <tr className="bg-gray-200">
//             <th className="border border-black px-1 py-1 w-7">#</th>
//             <th className="border border-black px-2 py-1 text-left">Product Description</th>
//             <th className="border border-black px-1 py-1 w-16">HSN Code</th>
//             <th className="border border-black px-1 py-1 w-12">UOM</th>
//             <th className="border border-black px-1 py-1 w-14">Qty</th>
//             <th className="border border-black px-1 py-1 w-16">Rate</th>
//             <th className="border border-black px-1 py-1 w-20">Amount</th>
//           </tr>
//         </thead>
//         <tbody>
//           {safeItems.length > 0 ? (
//             safeItems.map((item, i) => {
//               const qty = parseFloat(item.qty) || 0;
//               const rate = parseFloat(item.ratePerQtl) || 0;
//               const amount = qty * rate;
//               return (
//                 <tr key={i}>
//                   <td className="border border-black px-1 py-1 text-center">{i + 1}</td>
//                   <td className="border border-black px-2 py-1">{item.name || "—"}</td>
//                   <td className="border border-black px-1 py-1 text-center">—</td>
//                   <td className="border border-black px-1 py-1 text-center">Qtl</td>
//                   <td className="border border-black px-1 py-1 text-right">{item.qty || "—"}</td>
//                   <td className="border border-black px-1 py-1 text-right">{rate > 0 ? `₹${rate.toLocaleString("en-IN")}` : "—"}</td>
//                   <td className="border border-black px-1 py-1 text-right">{amount > 0 ? `₹${amount.toLocaleString("en-IN")}` : "—"}</td>
//                 </tr>
//               );
//             })
//           ) : (
//             <>
//               {[0, 1, 2, 3].map((i) => (
//                 <tr key={i} className="h-6">
//                   <td className="border border-black px-1 py-1 text-center"></td>
//                   <td className="border border-black px-2 py-1 italic text-gray-300">{i === 0 ? "No items added yet" : ""}</td>
//                   <td className="border border-black px-1 py-1"></td>
//                   <td className="border border-black px-1 py-1"></td>
//                   <td className="border border-black px-1 py-1"></td>
//                   <td className="border border-black px-1 py-1"></td>
//                   <td className="border border-black px-1 py-1"></td>
//                 </tr>
//               ))}
//             </>
//           )}
//         </tbody>
//       </table>

//       {/* ── TOTALS SECTION ── */}
//       <div className="flex border-t border-black">
//         <div className="flex-1 px-2 py-2 border-r border-black text-[10px]">
//           <p className="font-bold text-[11px] mb-1">GST WILL BE PAID BY CONSIGNEE'S</p>
//           <p className="font-bold mb-0.5">1. BANK NAME:- {sender?.bank_name || "—"}</p>
//           <p>
//             A/C No. {sender?.bank_account_number || "—"} &nbsp; IFSC CODE:- {sender?.bank_ifsc || "—"}
//           </p>
//         </div>
//         <div className="w-56 text-[11px]">
//           {[["SUB. Total Amount", totalFromItems(safeItems)], ["ROUND OFF", ""]].map(([label, val]) => (
//             <div key={label} className="flex justify-between items-center px-2 py-1 border-b border-gray-300">
//               <span>{label}</span>
//               <span className="font-bold">{val || ""}</span>
//             </div>
//           ))}
//           <div className="flex justify-between items-center px-2 py-1 border-b-2 border-black font-black">
//             <span>Total Amount</span>
//             <span>{totalFromItems(safeItems)}</span>
//           </div>
//           {[
//             ["INVOICE NO.:-", displayLrNo],
//             ["INVOICE VALUE :-", ""],
//             ["DELIVERY AT:-", det.destination || ""],
//             ["EWAY BILL NO.", ""],
//           ].map(([label, val]) => (
//             <div key={label} className="flex justify-between items-center px-2 py-1 border-b border-gray-200">
//               <span className="whitespace-nowrap">{label}</span>
//               <span className="font-bold text-right">{val}</span>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="flex border-t border-black">
//         <div className="flex-1 px-2 py-2 border-r border-black text-[10px]">
//           <p className="font-bold mb-0.5">{subject}</p>
//           <p className="font-bold mb-0.5">TERMS &amp; CONDITION :-</p>
//           <p className="text-gray-500">CARRIERS ARE NOT RESPONSIBLE FOR LEAKAGE, BREAKAGE, WATER DAMAGES.</p>
//           <p className="font-bold mt-1">E.&amp;O.E.</p>
//         </div>
//         <div className="w-56 px-3 py-2 text-left text-[10px]">
//           <div className="h-14" />
//           <div style={{ textAlign: "right" }}>
//             <img src={`${process.env.REACT_APP_API_URL}${company?.signature}`} alt="Company Signature" style={{ display: "inline-block" }} />
//           </div>
//           <p className="font-bold">{formatEntity(transporter)}</p>
//           <p>For - {formatEntity(company) || "COMPANY NAME"}</p>
//           <p className="font-bold">Authorised signatory</p>
//         </div>
//       </div>
//       <div className="flex border-t border-black">
//         <div className="flex-1 px-2 py-1.5 border-r border-black text-[10px]">
//           <span className="font-bold">PAYMENT MODE: </span>
//           <span className={`ml-1 font-bold px-2 py-0.5 rounded ${paymentType === "paid" ? "bg-black text-white" : paymentType === "to_pay" ? "border border-black text-black" : paymentType === "credit" ? "border border-black text-black" : "border border-black/20 text-black"}`}>
//             {paymentLabel}
//           </span>
//         </div>
//         {step === 7 && submittedData && (
//           <div className="px-2 py-1.5 text-[10px] text-right">
//             <span className="font-bold text-green-700">✓ Invoice Generated</span>
//             <p className="font-mono text-[10px]">{submittedData.invoiceId}</p>
//           </div>
//         )}
//       </div>
//       {(() => {
//         function numberToWords(num: number): string {
//           if (num === 0) return "Zero";
//           const a = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
//           const b = ["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
//           const g = ["","Thousand","Lakh","Crore"];
//           function toWords(num: number): string {
//             if (num < 20) return a[num];
//             if (num < 100) return b[Math.floor(num / 10)] + (num % 10 ? " " + a[num % 10] : "");
//             if (num < 1000) return a[Math.floor(num / 100)] + " Hundred" + (num % 100 ? " " + toWords(num % 100) : "");
//             const chunks: number[] = [];
//             chunks.push(num % 1000); let n = Math.floor(num / 1000);
//             while (n > 0) { chunks.push(n % 100); n = Math.floor(n / 100); }
//             let res = '';
//             for (let i = chunks.length - 1; i >= 0; i--)
//               if (chunks[i]) res += (res ? " " : "") + toWords(chunks[i]) + (g[i] ? " " + g[i] : "");
//             return res.trim();
//           }
//           const parts = num.toFixed(2).split(".");
//           let wordStr = toWords(parseInt(parts[0]));
//           if (parseInt(parts[1], 10) > 0) wordStr += " and " + toWords(parseInt(parts[1], 10)) + " Paise";
//           return wordStr;
//         }
//         const grandTotal = safeItems.reduce((sum, item) => {
//           const qty = parseFloat(item.qty) || 0;
//           const rate = parseFloat(item.ratePerQtl) || 0;
//           return sum + qty * rate;
//         }, 0);
//         return (
//           <div className="px-2 py-1 border-t border-black text-[10px]">
//             <span className="font-bold">AMOUNT IN WORDS :- </span>
//             <span className="italic text-gray-500">
//               {grandTotal > 0 ? numberToWords(grandTotal).toUpperCase() + "  ONLY /-" : ""}
//             </span>
//           </div>
//         );
//       })()}
//       <div className="text-center text-[9px] text-gray-500 py-1 border-t border-black">
//         THIS IS COMPUTER GENERATED LR. DOES NOT REQUIRE SIGN.
//       </div>
//     </div>
//   );
// }

// export const AddConsignment: React.FC = () => {
//   const [step, setStep] = useState(0);
//   const [company, setCompany] = useState<any>(null);
//   const [sender, setSender] = useState<any>(null);
//   const [receiver, setReceiver] = useState<any>(null);
//   const [selectedTransporterMock, setSelectedTransporterMock] = useState<any | null>(null);
//   const [selectedVehicle, setSelectedVehicle] = useState<any | null>(null);
//   const [selectedDriver, setSelectedDriver] = useState<any | null>(null);
//   const [singletransporter, setSingleTransporter] = useState<any>(null);
//   const [consignmentDetails, setConsignmentDetails] = useState<any>({ origin: "", destination: "", description: "" });
//   const [items, setItems] = useState<Item[]>([{ name: "", qty: "", weight: "", ratePerQtl: "" }]);
//   const [paymentType, setPaymentType] = useState("paid");
//   const [submittedData, setSubmittedData] = useState<any>(null);
//   const [pdfUrl, setPdfUrl] = useState<string | null>(null);
//   const [showInvoiceModal, setShowInvoiceModal] = useState(false);
//   const previewPanelRef = useRef<HTMLDivElement>(null);
//   const [subject, setSubject] = useState<string>("");
//   const [paymentPayableConsignor, setPaymentPayableConsignor] = useState<"sender" | "receiver">("sender");
//   const [companySearch, setCompanySearch] = useState("");
//   const [senderSearch, setSenderSearch] = useState("");
//   const [receiverSearch, setReceiverSearch] = useState("");
//   const [selectedDate, setSelectedDate] = useState(() => {
//     const d = new Date();
//     return d.toISOString().slice(0, 10);
//   });
//   const [showShareOptions, setShowShareOptions] = useState(false);
//   const [hasBroker, setHasBroker] = useState(false);
//   const [brokerPaidBy, setBrokerPaidBy] = useState<"receiver" | "sender" | null>(null);

//   // ✅ NEW: Manual invoice number state
//   const [invoiceNumber, setInvoiceNumber] = useState<string>("");

//   const [companiesMock, setCompanies] = useState<any[]>([]);
//   const [sendersMock, setSenders] = useState<any[]>([]);
//   const [receiversMock, setReceivers] = useState<any[]>([]);
//   const [transporters, setTransporters] = useState<any[]>([]);
//   const [drivers, setDrivers] = useState<any[]>([]);
//   const [vehicles, setVehicles] = useState<any[]>([]);

//   useEffect(() => {
//     axios.get(`${process.env.REACT_APP_API_URL}/auth/transporters`).then(res => setTransporters(res.data));
//     axios.get(`${process.env.REACT_APP_API_URL}/auth/drivers`).then(res => setDrivers(res.data));
//     axios.get(`${process.env.REACT_APP_API_URL}/auth/vehicles`).then(res => setVehicles(res.data));
//     const fetchSenders = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}/auth/alluser/consignor`);
//         setSenders(response.data || []);
//       } catch { setSenders([]); }
//     };
//     const fetchReceivers = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}/auth/alluser/consignor`);
//         setReceivers(response.data || []);
//       } catch { setReceivers([]); }
//     };
//     fetchSenders();
//     fetchReceivers();
//   }, []);

//   useEffect(() => {
//     const fetchCompanies = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}/companyAuth/companies`);
//         setCompanies(
//           response.data.map((company: any) => ({
//             ...company,
//             id: company.id ?? company.company_id,
//             company_name: company.company_name ?? company.name ?? "",
//             address: company.address ?? null,
//             password: company.password ?? "",
//             pancard: company.pancard ?? "",
//             city: company.city ?? company.company_city ?? null,
//             state: company.state ?? null,
//             country: company.country ?? null,
//             gst_number: company.gst_number ?? company.company_gst ?? company.gst ?? null,
//             gst_uin: company.gst_uin ?? null,
//             code: company.code ?? null,
//             cin: company.cin ?? null,
//             email: company.email ?? null,
//             created_at: company.created_at ?? "",
//             updated_at: company.updated_at ?? "",
//             HSN_SAC: company.HSN_SAC ?? "",
//             GST_SLAB: company.GST_SLAB ?? null,
//             signature: company.signature ?? "",
//             prefix: company.prefix ?? "",
//             postfix: company.postfix ?? "",
//             separatorsign: company.separatorsign ?? "",
//           }))
//         );
//       } catch { setCompanies([]); }
//     };
//     fetchCompanies();
//   }, []);

//   const vehiclesForDriver = vehicles;

//   const isStepValid = () => {
//     switch (step) {
//       case 0: return !!selectedVehicle && !!selectedDriver;
//       case 1: return !!company;
//       case 2: return !!sender;
//       case 3: return !!receiver;
//       case 4: return !!consignmentDetails.origin && !!consignmentDetails.destination;
//       case 5: return !!items[0]?.name;
//       case 6: return !!paymentType && paymentPayableConsignor;
//       default: return true;
//     }
//   };

//   const S = StyleSheet.create({
//     page: { fontFamily: 'Helvetica', fontSize: 9, color: '#000', backgroundColor: '#fff', border: '2px solid black', padding: '12px' },
//     header: { borderBottom: '2px solid black', paddingVertical: 5, paddingHorizontal: 8, alignItems: 'center' },
//     companyName: { fontSize: 20, fontFamily: 'Helvetica-Bold', letterSpacing: 2 },
//     companyAddress: { fontSize: 8, marginTop: 2 },
//     row: { flexDirection: 'row' },
//     gstRow: { flexDirection: 'row', borderBottom: '1px solid black' },
//     gstCell: { flex: 1, paddingHorizontal: 6, paddingVertical: 3, borderRight: '1px solid black' },
//     gstLabel: { fontSize: 7, color: '#888', textTransform: 'uppercase', marginBottom: 1 },
//     gstValue: { fontSize: 9, fontFamily: 'Helvetica-Bold' },
//     ownersRisk: { paddingHorizontal: 6, paddingVertical: 3, minWidth: 90, alignItems: 'flex-end', justifyContent: 'flex-end' },
//     ownersRiskText: { fontSize: 7, color: '#888' },
//     emailRow: { borderBottom: '1px solid black', paddingHorizontal: 6, paddingVertical: 2 },
//     emailText: { fontSize: 8 },
//     banner: { backgroundColor: '#e5e5e5', borderBottom: '1px solid black', paddingVertical: 2, alignItems: 'center' },
//     bannerText: { fontSize: 7, letterSpacing: 1, textTransform: 'uppercase' },
//     consignBlock: { flexDirection: 'row', borderBottom: '1px solid black' },
//     consignLeft: { flex: 1, paddingHorizontal: 6, paddingVertical: 5, borderRight: '1px solid black' },
//     consignLabel: { fontSize: 7, color: '#888', textTransform: 'uppercase', marginBottom: 2 },
//     consignName: { fontSize: 11, fontFamily: 'Helvetica-Bold' },
//     consignAddress: { fontSize: 8, color: '#555', marginTop: 2 },
//     consignRight: { width: 170, paddingHorizontal: 6, paddingVertical: 5 },
//     detailRow: { flexDirection: 'row', alignItems: 'center', marginBottom: 2 },
//     detailLabel: { fontFamily: 'Helvetica-Bold', fontSize: 8, marginRight: 3 },
//     detailValue: { fontSize: 8 },
//     noteBox: { width: 170, paddingHorizontal: 8, paddingVertical: 5, justifyContent: 'center', alignItems: 'center' },
//     noteText: { color: 'red', fontFamily: 'Helvetica-Bold', fontSize: 9, textAlign: 'center', lineHeight: 1.3 },
//     table: { width: '100%' },
//     tableHeaderRow: { flexDirection: 'row', backgroundColor: '#e5e5e5' },
//     tableRow: { flexDirection: 'row' },
//     th: { border: '1px solid black', paddingHorizontal: 4, paddingVertical: 3, fontFamily: 'Helvetica-Bold', fontSize: 8, textAlign: 'center' },
//     td: { border: '1px solid black', paddingHorizontal: 4, paddingVertical: 3, fontSize: 8 },
//     totalsRow: { flexDirection: 'row', borderTop: '1px solid black' },
//     totalsLeft: { flex: 1, borderRight: '1px solid black', paddingHorizontal: 6, paddingVertical: 5 },
//     totalsRight: { width: 170 },
//     totalLineRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 6, paddingVertical: 2, borderBottom: '1px solid #ccc' },
//     totalLineBold: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 6, paddingVertical: 3, borderBottom: '2px solid black' },
//     totalLineLight: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 6, paddingVertical: 2, borderBottom: '1px solid #eee' },
//     totalLabel: { fontSize: 8 },
//     totalValue: { fontSize: 8, fontFamily: 'Helvetica-Bold' },
//     footerRow: { flexDirection: 'row', borderTop: '1px solid black' },
//     footerLeft: { flex: 1, borderRight: '1px solid black', paddingHorizontal: 6, paddingVertical: 5 },
//     footerRight: { width: 170, paddingHorizontal: 8, paddingVertical: 5, alignItems: 'flex-end' },
//     paymentRow: { flexDirection: 'row', borderTop: '1px solid black', paddingHorizontal: 6, paddingVertical: 3, alignItems: 'center' },
//     amountWordsRow: { borderTop: '1px solid black', paddingHorizontal: 6, paddingVertical: 3 },
//     computerNote: { borderTop: '1px solid black', paddingVertical: 3, alignItems: 'center' },
//     bold: { fontFamily: 'Helvetica-Bold' },
//     gray: { color: '#888' },
//     small: { fontSize: 7 },
//     red: { color: 'red' },
//   });

//   function numberToWords(num: number): string {
//     if (!num || num === 0) return '';
//     const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
//     const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
//     const g = ['', 'Thousand', 'Lakh', 'Crore'];
//     function toW(n: number): string {
//       if (n < 20) return a[n];
//       if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
//       if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + toW(n % 100) : '');
//       const chunks: number[] = [];
//       chunks.push(n % 1000); let nn = Math.floor(n / 1000);
//       while (nn > 0) { chunks.push(nn % 100); nn = Math.floor(nn / 100); }
//       let res = '';
//       for (let i = chunks.length - 1; i >= 0; i--)
//         if (chunks[i]) res += (res ? ' ' : '') + toW(chunks[i]) + (g[i] ? ' ' + g[i] : '');
//       return res.trim();
//     }
//     const parts = num.toFixed(2).split('.');
//     let str = toW(parseInt(parts[0]));
//     if (parseInt(parts[1]) > 0) str += ' and ' + toW(parseInt(parts[1])) + ' Paise';
//     return str.toUpperCase() + ' ONLY /-';
//   }

//   function InvoicePDF({ company, sender, receiver, selectedVehicle, consignmentDetails, items, paymentType, submittedData, subject, transporter }: any) {
//     const safeItems = Array.isArray(items) ? items.filter((i: any) => i?.name) : [];
//     const total = safeItems.reduce((sum: number, item: any) => sum + (parseFloat(item.qty) || 0) * (parseFloat(item.ratePerQtl) || 0), 0);
//     const paymentLabel = paymentType === 'paid' ? 'Paid' : paymentType === 'to_pay' ? 'To Pay' : 'Credit';
//     const colFlex = [0.4, 3, 1, 0.8, 0.8, 0.8, 1];
//     const colHeaders = ['#', 'Product Description', 'HSN Code', 'UOM', 'Qty', 'Rate', 'Amount'];
//     const colAlign: ('left' | 'center' | 'right')[] = ['center', 'left', 'center', 'center', 'right', 'right', 'right'];
//     const displayItems = safeItems.length > 0
//       ? safeItems
//       : [{ name: '', qty: '', ratePerQtl: '' }, { name: '', qty: '', ratePerQtl: '' }, { name: '', qty: '', ratePerQtl: '' }, { name: '', qty: '', ratePerQtl: '' }];

//     return (
//       <Document>
//         <Page size="A4" style={S.page}>
//           <View style={S.header}>
//             <Text style={S.companyName}>{company?.company_name || 'COMPANY NAME'}</Text>
//             <Text style={S.companyAddress}>{company?.address || 'COMPANY ADDRESS'}</Text>
//           </View>
//           <View style={S.gstRow}>
//             <View style={S.gstCell}><Text style={S.gstLabel}>GST Enrol No:</Text><Text style={S.gstValue}>{company?.gst_number || '—'}</Text></View>
//             <View style={S.gstCell}><Text style={S.gstLabel}>PAN No.</Text><Text style={S.gstValue}>{company?.pancard || '—'}</Text></View>
//             <View style={S.ownersRisk}><Text style={S.ownersRiskText}>AT OWNERS RISK</Text></View>
//           </View>
//           <View style={S.emailRow}><Text style={S.emailText}>Email Id. - {company?.email || ''}</Text></View>
//           <View style={S.banner}><Text style={S.bannerText}>{subject || 'Subject to Kishangarh Jurisdiction'}</Text></View>
//           <View style={S.consignBlock}>
//             <View style={S.consignLeft}>
//               <Text style={S.consignLabel}>Consignor's / Supplier's Name & Address</Text>
//               <Text style={S.consignName}>{sender?.name || '—'}</Text>
//               <Text style={S.consignAddress}>{sender?.address || ''}</Text>
//             </View>
//             <View style={S.consignRight}>
//               {submittedData?.invoiceId && <View style={S.detailRow}><Text style={S.detailLabel}>GR NO.:-</Text><Text style={S.detailValue}>{submittedData.invoiceId}</Text></View>}
//               <View style={S.detailRow}><Text style={S.detailLabel}>DATED :-</Text><Text style={S.detailValue}>{submittedData?.date ? new Date(submittedData.date).toLocaleDateString('en-IN') : new Date().toLocaleDateString('en-IN')}</Text></View>
//               <View style={S.detailRow}><Text style={S.detailLabel}>{(selectedVehicle?.vehicle_type || 'TRUCK').toUpperCase()} NO.:-</Text><Text style={S.detailValue}>{selectedVehicle?.vehicle_number || '—'}</Text></View>
//               <View style={S.detailRow}><Text style={S.detailLabel}>FROM :-</Text><Text style={S.detailValue}>{consignmentDetails?.origin || '—'}</Text></View>
//               <View style={S.detailRow}><Text style={S.detailLabel}>To:-</Text><Text style={S.detailValue}>{consignmentDetails?.destination || '—'}</Text></View>
//             </View>
//           </View>
//           <View style={S.consignBlock}>
//             <View style={S.consignLeft}>
//               <Text style={S.consignLabel}>Consignee's / Recipient's Name & Address</Text>
//               <Text style={S.consignName}>{receiver?.name || '—'}</Text>
//               <Text style={S.consignAddress}>{receiver?.address || ''}</Text>
//             </View>
//             <View style={S.noteBox}><Text style={S.noteText}>NOTE- NO CASH ONLY CHEQUE OR POD</Text></View>
//           </View>
//           <View style={S.table}>
//             <View style={S.tableHeaderRow}>
//               {colHeaders.map((h, i) => (
//                 <View key={h} style={[S.th, { flex: colFlex[i], textAlign: colAlign[i] }]}><Text>{h}</Text></View>
//               ))}
//             </View>
//             {displayItems.map((item: any, i: number) => {
//               const qty = parseFloat(item.qty) || 0;
//               const rate = parseFloat(item.ratePerQtl) || 0;
//               const amount = qty * rate;
//               return (
//                 <View key={i} style={S.tableRow}>
//                   <View style={[S.td, { flex: colFlex[0], textAlign: 'center' }]}><Text>{item.name ? String(i + 1) : ''}</Text></View>
//                   <View style={[S.td, { flex: colFlex[1], textAlign: 'left' }]}><Text>{item.name || ''}</Text></View>
//                   <View style={[S.td, { flex: colFlex[2], textAlign: 'center' }]}><Text>{item.name ? '—' : ''}</Text></View>
//                   <View style={[S.td, { flex: colFlex[3], textAlign: 'center' }]}><Text>{item.name ? 'Qtl' : ''}</Text></View>
//                   <View style={[S.td, { flex: colFlex[4], textAlign: 'right' }]}><Text>{item.qty || ''}</Text></View>
//                   <View style={[S.td, { flex: colFlex[5], textAlign: 'right' }]}><Text>{rate > 0 ? `₹${rate}` : ''}</Text></View>
//                   <View style={[S.td, { flex: colFlex[6], textAlign: 'right' }]}><Text>{amount > 0 ? `₹${amount.toLocaleString('en-IN')}` : ''}</Text></View>
//                 </View>
//               );
//             })}
//           </View>
//           <View style={S.totalsRow}>
//             <View style={S.totalsLeft}>
//               <Text style={[S.bold, { fontSize: 9, marginBottom: 3 }]}>GST WILL BE PAID BY CONSIGNEE'S</Text>
//               <Text style={[S.bold, { fontSize: 8, marginBottom: 2 }]}>
//                 1. BANK NAME:- {sender?.bank_name || '—'}
//               </Text>
//               <Text style={{ fontSize: 8 }}>
//                 A/C No. {sender?.bank_account_number || '—'}{'   '}IFSC CODE:- {sender?.bank_ifsc || '—'}
//               </Text>
//             </View>
//             <View style={S.totalsRight}>
//               <View style={S.totalLineRow}><Text style={S.totalLabel}>SUB. Total Amount</Text><Text style={S.totalValue}>{total > 0 ? `₹${total.toLocaleString('en-IN')}` : ''}</Text></View>
//               <View style={S.totalLineRow}><Text style={S.totalLabel}>ROUND OFF</Text><Text style={S.totalValue}></Text></View>
//               <View style={S.totalLineBold}><Text style={[S.totalLabel, S.bold]}>Total Amount</Text><Text style={[S.totalValue, S.bold]}>{total > 0 ? `₹${total.toLocaleString('en-IN')}` : ''}</Text></View>
//               <View style={S.totalLineLight}><Text style={S.totalLabel}>INVOICE NO.:-</Text><Text style={S.totalValue}>{submittedData?.invoiceId || ''}</Text></View>
//               <View style={S.totalLineLight}><Text style={S.totalLabel}>INVOICE VALUE :-</Text><Text style={S.totalValue}></Text></View>
//               <View style={S.totalLineLight}><Text style={S.totalLabel}>DELIVERY AT:-</Text><Text style={S.totalValue}>{consignmentDetails?.destination || ''}</Text></View>
//               <View style={S.totalLineLight}><Text style={S.totalLabel}>EWAY BILL NO.</Text><Text style={S.totalValue}></Text></View>
//             </View>
//           </View>
//           <View style={S.footerRow}>
//             <View style={S.footerLeft}>
//               <Text style={[S.bold, { fontSize: 8, marginBottom: 2 }]}>SUBJECT TO KISHANGARH JURISDICTION</Text>
//               <Text style={[S.bold, { fontSize: 8, marginBottom: 2 }]}>TERMS & CONDITION :-</Text>
//               <Text style={[S.gray, { fontSize: 8, marginBottom: 4 }]}>CARRIERS ARE NOT RESPONSIBLE FOR LEAKAGE, BREAKAGE, WATER DAMAGES.</Text>
//               <Text style={[S.bold, { fontSize: 8 }]}>E.&O.E.</Text>
//             </View>
//             <View style={S.footerRight}>
//               <Text style={[S.bold, { fontSize: 8, marginBottom: 2 }]}>For {company?.company_name || 'COMPANY NAME'}</Text>
//               <View style={{ height: 36 }}>
//                 {company?.signature ? <Image src={`${process.env.REACT_APP_API_URL}${company.signature}`} style={{ maxHeight: 36, objectFit: 'contain' }} /> : null}
//               </View>
//               <Text style={[S.bold, { fontSize: 8 }]}>{transporter?.company_name || '—'}</Text>
//               <Text style={{ fontSize: 8 }}>For - {company?.company_name || 'COMPANY NAME'}</Text>
//               <Text style={[S.bold, { fontSize: 8 }]}>Authorised signatory</Text>
//             </View>
//           </View>
//           <View style={S.paymentRow}>
//             <Text style={[S.bold, { fontSize: 8 }]}>PAYMENT MODE: </Text>
//             <Text style={[S.bold, { fontSize: 8, marginLeft: 4, paddingHorizontal: 6, paddingVertical: 1, backgroundColor: paymentType === 'paid' ? '#000' : '#fff', color: paymentType === 'paid' ? '#fff' : '#000', border: '1px solid black' }]}>{paymentLabel}</Text>
//           </View>
//           <View style={S.amountWordsRow}>
//             <Text style={{ fontSize: 8 }}>
//               <Text style={S.bold}>AMOUNT IN WORDS :- </Text>
//               <Text style={[S.gray, { fontStyle: 'italic' }]}>{total > 0 ? numberToWords(total) : ''}</Text>
//             </Text>
//           </View>
//           <View style={S.computerNote}><Text style={[S.gray, S.small]}>THIS IS COMPUTER GENERATED LR. DOES NOT REQUIRE SIGN.</Text></View>
//         </Page>
//       </Document>
//     );
//   }

//   async function generatePdfAndSendToServer(invoiceId: string): Promise<string> {
//     const blob = await pdf(
//       <InvoicePDF
//         company={company}
//         sender={sender}
//         receiver={receiver}
//         selectedVehicle={selectedVehicle}
//         consignmentDetails={consignmentDetails}
//         items={items}
//         paymentType={paymentType}
//         submittedData={{ ...submittedData, invoiceId, date: selectedDate }}
//         subject={subject}
//         transporter={singletransporter}
//       />
//     ).toBlob();
//     const filename = `invoice_${invoiceId}.pdf`;
//     try {
//       const formData = new FormData();
//       formData.append("invoicePdf", blob, filename);
//       formData.append("invoiceId", invoiceId);
//       const uploadResp = await axios.post(`${process.env.REACT_APP_API_URL}/invoiceapi/uploadpdf`, formData, { headers: { "Content-Type": "multipart/form-data" } });
//       const link = uploadResp.data?.link ? `${process.env.REACT_APP_API_URL}${uploadResp.data.link}` : "";
//       if (link) setPdfUrl(link);
//       return link;
//     } catch {
//       alert("Failed to upload invoice PDF to server.");
//       return "";
//     }
//   }

//   async function submitConsignmentToApiAndPdf() {
//     // ✅ Use manual invoice number if provided, otherwise auto-generate
//     const invoiceId = invoiceNumber.trim()
//       ? invoiceNumber.trim()
//       : generateInvoiceId(consignmentDetails.origin, consignmentDetails.destination, selectedVehicle?.vehicle_number, selectedDate);

//     const ewaybillno = invoiceId;
//     let totoalamount = totalFromItems(items);
//     let paymentPayableConsignorId = paymentPayableConsignor === "sender" ? sender?.id : receiver?.id;
//     const link = await generatePdfAndSendToServer(invoiceId);
//     if (!link) return;
//     let itemDescriptionsIds: number[] = [];
//     for (const item of items) {
//       if (!item.name) continue;
//       try {
//         const computedAmount = (parseFloat(item.qty) || 0) * (parseFloat(item.ratePerQtl) || 0);
//         const res = await axios.post(`${process.env.REACT_APP_API_URL}/invoiceapi/invoice_items`, {
//           invoiceId, description: item.name, hsm_code: "-", uom: "Qtl", qty: item.qty, amount: computedAmount.toString()
//         });
//         if (res.data && typeof res.data.insertId === "number") itemDescriptionsIds.push(res.data.insertId);
//       } catch (e) { alert("Failed to add item '" + item.name + "' to invoice_items!"); }
//     }

//     // ✅ Resolve broker_id: the user ID of whoever is paying the broker
//     const brokerUserId =
//       hasBroker && brokerPaidBy === "sender"
//         ? sender?.id
//         : hasBroker && brokerPaidBy === "receiver"
//         ? receiver?.id
//         : null;

//     const invoicePayload = {
//       company: company?.id,
//       sender: sender?.id,
//       receiver: receiver?.id,
//       payment: totoalamount,
//       transporter: singletransporter?.id || selectedTransporterMock?._rawTransporter?.id,
//       driver: selectedDriver?.id,
//       vehicles: selectedVehicle?.id,
//       source: consignmentDetails.origin,
//       destination: consignmentDetails.destination,
//       description: consignmentDetails.description,
//       receiverAmountStatatus: "Pending",
//       senderAmountStatatus: "Pending",
//       transporterAmountStatatus: "Pending",
//       subjects: subject,
//       InvoiceNo: invoiceId,
//       EWAYBILLNO: ewaybillno,
//       paymentType,
//       paymentPayableConsignor: paymentPayableConsignorId,
//       date: selectedDate,
//       subject,
//       paymentStatus: paymentType,
//       ItemsDescription: JSON.stringify(itemDescriptionsIds),
//       link,
//       // ✅ Broker fields — null when no broker involved
//       broker: brokerUserId,
//       broker_paid_by: hasBroker ? brokerPaidBy : null,
//     };

//     try {
//       await axios.post(`${process.env.REACT_APP_API_URL}/invoiceapi/invoice`, invoicePayload);
//     } catch (error) {
//       alert("Failed to create invoice/consignment\n" + (error && (error as any)?.message));
//       return false;
//     }
//     setSubmittedData({ company, sender, receiver, singletransporter, consignmentDetails, items, paymentType, date: selectedDate, invoiceId, paymentPayableConsignorId, subject, ewaybillno });
//     await new Promise(r => setTimeout(r, 200));
//     setPdfUrl(link);
//     setShowInvoiceModal(true);
//     return true;
//   }

//   const handleNext = async () => {
//     if (step === 0 && selectedVehicle && selectedDriver) {
//       const owningTransporter = transporters.find(t => t.id === selectedVehicle.transporter_id) || null;
//       setSingleTransporter(owningTransporter ? {
//         ...owningTransporter,
//         vehicle: { id: selectedVehicle.id, registration_number: selectedVehicle.registration_number, vehicle_number: selectedVehicle.vehicle_number, vehicle_type: selectedVehicle.vehicle_type, driver_id: selectedDriver.id, capacity_kg: 0 },
//         driver: selectedDriver
//       } : {
//         id: null, company_name: "—",
//         vehicle: { id: selectedVehicle.id, registration_number: selectedVehicle.registration_number, vehicle_number: selectedVehicle.vehicle_number, vehicle_type: selectedVehicle.vehicle_type, driver_id: selectedDriver.id, capacity_kg: 0 },
//         driver: selectedDriver
//       });
//     }
//     if (step === steps.length - 2) {
//       const ok = await submitConsignmentToApiAndPdf();
//       if (!ok) return;
//       setStep(s => s + 1);
//     } else {
//       setStep(s => s + 1);
//     }
//   };

//   const canNavigateBack = step !== 0 && step < steps.length - 1;

//   function handleDownloadPdf() {
//     if (pdfUrl) { window.open(pdfUrl, "_blank"); } else { alert("PDF not available"); }
//   }

//   function handleSharePdf() {
//     if (!pdfUrl) return;
//     if (navigator.share) { navigator.share({ title: "Consignment Invoice", url: pdfUrl }).catch(() => { }); }
//     else { setShowShareOptions(true); }
//   }

//   function handleNewConsignment() {
//     setStep(0); setCompany(null); setSender(null); setReceiver(null); setSingleTransporter(null);
//     setConsignmentDetails({ origin: "", destination: "", description: "" });
//     setItems([{ name: "", qty: "", weight: "", ratePerQtl: "" }]);
//     setPaymentType("paid"); setSubmittedData(null);
//     setSelectedDate(new Date().toISOString().slice(0, 10));
//     setSubject(""); setPaymentPayableConsignor("sender"); setPdfUrl(null); setShowInvoiceModal(false);
//     setHasBroker(false); setBrokerPaidBy(null);
//     setSelectedTransporterMock(null); setSelectedVehicle(null); setSelectedDriver(null);
//     // ✅ Reset invoice number
//     setInvoiceNumber("");
//   }

//   const updateItem = (idx: number, key: keyof Item, value: string) => {
//     setItems(prev => prev.map((it, i) => i === idx ? { ...it, [key]: value } : it));
//   };

//   const itemTotal = (item: Item) => (parseFloat(item.qty) || 0) * (parseFloat(item.ratePerQtl) || 0);
//   const grandTotal = items.reduce((acc, it) => acc + itemTotal(it), 0);

//   const dropdownCls = "w-full border-2 border-blue-300 rounded-lg px-4 py-3 text-base text-blue-900 bg-white font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500 transition appearance-none cursor-pointer";

//   return (
//     <div className="min-h-screen w-full flex items-start justify-center py-8 px-2 bg-gradient-to-br from-[#cfdbff] via-[#edf1fe] to-[#edf1fe]">
//       <div className="w-full max-w-screen-2xl mx-auto flex flex-col md:flex-row overflow-hidden rounded-2xl shadow-2xl border-2 border-[#456bcb] min-h-screen md:min-h-[720px]">

//         {/* Sidebar */}
//         <div className="hidden md:flex flex-col w-64 shrink-0 bg-white py-12 px-8 gap-2 border-r-2 border-[#456bcb]">
//           <p className="text-[#456bcb] text-sm font-extrabold uppercase tracking-widest mb-8">Progress</p>
//           <div className="space-y-2">
//             {steps.map((label, idx) => {
//               const done = idx < step;
//               const active = idx === step;
//               return (
//                 <button key={label} type="button" onClick={() => done && canNavigateBack && setStep(idx)} disabled={step >= 7}
//                   className={`flex items-center gap-3 px-4 py-3 rounded-xl text-left transition-all border-l-4 ${active ? "bg-white border-blue-600 shadow-[0_2px_8px_rgba(47,87,181,0.13)]" : done ? "bg-blue-50 hover:bg-blue-100 border-blue-300 cursor-pointer" : "bg-transparent border-transparent cursor-default"}`}>
//                   <span className={`w-8 h-8 rounded-full flex items-center justify-center text-base font-extrabold shrink-0 border-2 ${active ? "bg-blue-700 text-white border-blue-700 shadow" : done ? "bg-white text-blue-800 border-blue-300" : "bg-blue-200 text-blue-300 border-blue-100"}`}>
//                     {done ? <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg> : idx + 1}
//                   </span>
//                   <span className={`text-base font-bold tracking-wide uppercase ${active ? "text-blue-800" : done ? "text-blue-600" : "text-blue-400"}`}>{label}</span>
//                 </button>
//               );
//             })}
//           </div>
//         </div>

//         {/* Main */}
//         <div className="flex-1 flex flex-col min-w-0 bg-transparent">
//           {/* Header */}
//           <div className="border-b-2 border-[#456bcb] px-10 py-6 bg-gradient-to-r from-[#ddeaff] to-[#f3f7fe] flex items-center gap-4">
//             <p className="text-sm text-[#2c4174] font-semibold mt-1">
//               Step <span className="text-blue-800 font-extrabold">{step + 1}</span> of <span className="text-blue-600">{steps.length}</span> — <span className="font-bold text-blue-700">{steps[step]}</span>
//             </p>
//             <div className="ml-auto flex items-center gap-2">
//               <label className="font-bold text-blue-700">Date:</label>
//               <input type="date" className="border-2 border-blue-300 rounded-lg px-2 py-1 font-bold bg-white text-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500 transition" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} max={new Date().toISOString().slice(0, 10)} />
//             </div>
//           </div>

//           {/* Mobile progress */}
//           <div className="flex md:hidden gap-1 px-4 py-3 border-b-2 border-[#456bcb] bg-transparent overflow-x-auto">
//             {steps.map((s, i) => <div key={s} className={`h-2 flex-1 rounded-full transition-all ${i <= step ? "bg-blue-600" : "bg-blue-200"}`} />)}
//           </div>

//           {/* Steps content */}
//           <div className="flex-1 px-6 md:px-10 py-6 md:py-8 overflow-y-auto w-full rounded-md bg-gradient-to-tr from-white via-blue-50 to-[#ebf1fd]">

//             {/* STEP 0: Driver, Vehicle & Invoice Number */}
//             {step === 0 && (
//               <div className="space-y-8 max-w-xl">
//                 <p className="text-lg font-extrabold text-blue-900">Select driver &amp; vehicle</p>
//                 <div className="space-y-2">
//                   <label className="text-base font-bold text-blue-800">Driver <span className="text-blue-700">*</span></label>
//                   <div className="relative">
//                     <select className={dropdownCls} value={selectedDriver?.id ?? ""} onChange={e => {
//                       const drv = drivers.find(d => d.id === Number(e.target.value)) || null;
//                       setSelectedDriver(drv);
//                       setSelectedVehicle(null);
//                     }}>
//                       <option value="">— Select a driver —</option>
//                       {drivers.map(drv => (
//                         <option key={drv.id} value={drv.id}>{drv.name}{drv.phone ? ` (${drv.phone})` : ""}</option>
//                       ))}
//                     </select>
//                     <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-blue-500">
//                       <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9" /></svg>
//                     </span>
//                   </div>
//                   {drivers.length === 0 && <p className="text-sm text-blue-400 italic">Loading drivers…</p>}
//                 </div>

//                 {selectedDriver && (
//                   <div className="space-y-2">
//                     <label className="text-base font-bold text-blue-800">Vehicle <span className="text-blue-700">*</span></label>
//                     <div className="relative">
//                       <select className={dropdownCls} value={selectedVehicle?.id ?? ""} onChange={e => {
//                         const veh = vehiclesForDriver.find((v: any) => v.id === Number(e.target.value)) || null;
//                         setSelectedVehicle(veh);
//                       }}>
//                         <option value="">— Select a vehicle —</option>
//                         {vehiclesForDriver.map((v: any) => (
//                           <option key={v.id} value={v.id}>{v.registration_number || v.vehicle_number}{v.vehicle_type ? ` — ${v.vehicle_type}` : ""}</option>
//                         ))}
//                       </select>
//                       <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-blue-500">
//                         <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9" /></svg>
//                       </span>
//                     </div>
//                     {vehiclesForDriver.length === 0 && <p className="text-sm text-blue-400 italic">No vehicles found.</p>}
//                   </div>
//                 )}

//                 {selectedDriver && selectedVehicle && (
//                   <div className="bg-blue-50 border-2 border-blue-200 rounded-xl px-5 py-4 flex flex-col gap-1 text-sm">
//                     <p className="font-extrabold text-blue-800 mb-1">Selected</p>
//                     <p className="text-blue-700"><span className="font-bold">Driver:</span> {selectedDriver.name}{selectedDriver.phone ? ` (${selectedDriver.phone})` : ""}</p>
//                     <p className="text-blue-700"><span className="font-bold">Vehicle:</span> {selectedVehicle.registration_number || selectedVehicle.vehicle_number}{selectedVehicle.vehicle_type ? ` — ${selectedVehicle.vehicle_type}` : ""}</p>
//                   </div>
//                 )}

//                 {/* ✅ NEW: Invoice / LR Number input */}
//                 <div className="space-y-2">
//                   <label className="text-base font-bold text-blue-800">
//                     Invoice / LR Number
//                     <span className="ml-2 text-blue-400 font-normal text-sm">(optional — auto-generated if blank)</span>
//                   </label>
//                   <input
//                     className="w-full border-2 border-blue-300 rounded-lg px-4 py-3 text-base text-blue-900 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition font-semibold tracking-widest uppercase placeholder:normal-case placeholder:tracking-normal placeholder:font-normal"
//                     placeholder="e.g. LR-2024-00123"
//                     value={invoiceNumber}
//                     onChange={e => setInvoiceNumber(e.target.value.toUpperCase())}
//                     maxLength={40}
//                   />
//                   {invoiceNumber.trim() ? (
//                     <p className="text-xs text-blue-600 font-semibold flex items-center gap-1.5">
//                       <svg className="w-3.5 h-3.5 text-green-600" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
//                       LR No. will be: <span className="font-mono font-black text-blue-800">{invoiceNumber.trim()}</span>
//                     </p>
//                   ) : (
//                     <p className="text-xs text-blue-400 italic">Leave blank to auto-generate from origin, destination &amp; vehicle.</p>
//                   )}
//                 </div>

//               </div>
//             )}

//             {/* STEP 1: Company */}
//             {step === 1 && (
//               <div className="space-y-4">
//                 <p className="text-lg font-extrabold text-blue-900 mb-3">Select your company</p>
//                 <div className="flex flex-col">
//                   <input type="text" value={companySearch} onChange={e => setCompanySearch(e.target.value)} className="mb-2 px-4 py-2 border-2 border-blue-300 rounded-lg bg-white font-semibold text-blue-900 text-base focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Search company by name, city or GST..." />
//                   <div className="max-h-64 overflow-y-auto flex flex-col gap-2 custom-scrollbar">
//                     {companiesMock.filter(c => (c.company_name + " " + c.city + " " + (c.gst_number || "")).toLowerCase().includes(companySearch.toLowerCase())).map(c => (
//                       <button key={c.id} type="button" onClick={() => setCompany(c)} className={`w-full flex items-center justify-between px-4 py-2 rounded-lg border-2 transition-all font-semibold text-base ${company && company.id === c.id ? "border-blue-700 bg-white shadow" : "border-blue-100 bg-blue-50"}`} style={{ minHeight: 0 }}>
//                         <div className="truncate max-w-xs text-left flex flex-col">
//                           <span className={`font-bold text-base truncate ${company && company.id === c.id ? "text-blue-800" : "text-blue-900"}`}>{c.company_name}</span>
//                           <span className={`text-xs truncate ${company && company.id === c.id ? "text-blue-500" : "text-blue-500/80"}`}>{c.city} &middot; GST: {c.gst_number}</span>
//                         </div>
//                         {company && company.id === c.id && <span className="ml-2 text-blue-700 shrink-0"><svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg></span>}
//                       </button>
//                     ))}
//                     {companiesMock.filter(c => (c.company_name + " " + c.city + " " + (c.gst_number || "")).toLowerCase().includes(companySearch.toLowerCase())).length === 0 && <div className="text-blue-400 italic text-sm py-2">No matching company found.</div>}
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* STEP 2: Sender */}
//             {step === 2 && (
//               <div className="space-y-4">
//                 <p className="text-lg font-extrabold text-blue-900 mb-3">Select sender</p>
//                 <div className="flex flex-col">
//                   <input type="text" value={senderSearch} onChange={e => setSenderSearch(e.target.value)} className="mb-2 px-4 py-2 border-2 border-blue-300 rounded-lg bg-white font-semibold text-blue-900 text-base focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Search sender by name, phone, address..." />
//                   <div className="max-h-64 overflow-y-auto flex flex-col gap-2 custom-scrollbar">
//                     {sendersMock.filter(s => (s.name + " " + s.phone + " " + s.address).toLowerCase().includes(senderSearch.toLowerCase())).map(s => (
//                       <button key={s.id} type="button" onClick={() => setSender(s)} className={`w-full flex items-center justify-between px-4 py-2 rounded-lg border-2 transition-all font-semibold text-base ${sender && sender.id === s.id ? "border-blue-700 bg-white shadow" : "border-blue-100 bg-blue-50"}`} style={{ height: 45 }}>
//                         <div className="flex flex-row items-center gap-3 w-full truncate">
//                           <span className={`font-bold text-base truncate ${sender && sender.id === s.id ? "text-blue-800" : "text-blue-900"}`}>{s.name}</span>
//                           <span className={`text-xs truncate ${sender && sender.id === s.id ? "text-blue-500" : "text-blue-600/80"}`}>{s.phone} &middot; {s.address}</span>
//                         </div>
//                         {sender && sender.id === s.id && <span className="ml-2 text-blue-700 shrink-0"><svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg></span>}
//                       </button>
//                     ))}
//                     {sendersMock.filter(s => (s.name + " " + s.phone + " " + s.address).toLowerCase().includes(senderSearch.toLowerCase())).length === 0 && <div className="text-blue-400 italic text-sm py-2">No matching sender found.</div>}
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* STEP 3: Receiver */}
//             {step === 3 && (
//               <div className="space-y-4">
//                 <p className="text-lg font-extrabold text-blue-900 mb-3">Select receiver</p>
//                 <div className="flex flex-col">
//                   <input type="text" value={receiverSearch} onChange={e => setReceiverSearch(e.target.value)} className="mb-2 px-4 py-2 border-2 border-blue-300 rounded-lg bg-white font-semibold text-blue-900 text-base focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Search receiver by name, phone, address..." />
//                   <div className="max-h-64 overflow-y-auto flex flex-col gap-2 custom-scrollbar">
//                     {receiversMock.filter(r => (r.name + " " + r.phone + " " + r.address).toLowerCase().includes(receiverSearch.toLowerCase())).map(r => (
//                       <button key={r.id} type="button" onClick={() => setReceiver(r)} className={`w-full flex items-center justify-between px-4 py-2 rounded-lg border-2 transition-all font-semibold text-base ${receiver && receiver.id === r.id ? "border-blue-700 bg-white shadow" : "border-blue-100 bg-blue-50"}`} style={{ height: 45 }}>
//                         <div className="flex flex-row items-center gap-3 w-full truncate">
//                           <span className={`font-bold text-base truncate ${receiver && receiver.id === r.id ? "text-blue-800" : "text-blue-900"}`}>{r.name}</span>
//                           <span className={`text-xs truncate ${receiver && receiver.id === r.id ? "text-blue-500" : "text-blue-600/80"}`}>{r.phone} &middot; {r.address}</span>
//                         </div>
//                         {receiver && receiver.id === r.id && <span className="ml-2 text-blue-700 shrink-0"><svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg></span>}
//                       </button>
//                     ))}
//                     {receiversMock.filter(r => (r.name + " " + r.phone + " " + r.address).toLowerCase().includes(receiverSearch.toLowerCase())).length === 0 && <div className="text-blue-400 italic text-sm py-2">No matching receiver found.</div>}
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* STEP 4: Details */}
//             {step === 4 && (
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
//                 <div className="flex flex-col gap-2">
//                   <label className="text-base font-bold text-blue-800">Origin Address <span className="text-blue-700">*</span></label>
//                   <input className="border-2 border-blue-300 rounded-lg px-4 py-3 text-base text-blue-900 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition font-semibold" placeholder="e.g. Mumbai Warehouse, Andheri" value={consignmentDetails.origin} onChange={e => setConsignmentDetails((d: any) => ({ ...d, origin: e.target.value }))} />
//                 </div>
//                 <div className="flex flex-col gap-2">
//                   <label className="text-base font-bold text-blue-800">Destination Address <span className="text-blue-700">*</span></label>
//                   <input className="border-2 border-blue-300 rounded-lg px-4 py-3 text-base text-blue-900 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition font-semibold" placeholder="e.g. Delhi Distribution Hub" value={consignmentDetails.destination} onChange={e => setConsignmentDetails((d: any) => ({ ...d, destination: e.target.value }))} />
//                 </div>
//                 <div className="sm:col-span-2 flex flex-col gap-2">
//                   <label className="text-base font-bold text-blue-800">Description <span className="text-blue-400 font-normal">(optional)</span></label>
//                   <textarea className="border-2 border-blue-300 rounded-lg px-4 py-3 text-base text-blue-900 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition resize-none font-semibold" rows={3} placeholder="Briefly describe this consignment..." value={consignmentDetails.description} onChange={e => setConsignmentDetails((d: any) => ({ ...d, description: e.target.value }))} />
//                 </div>
//                 <div className="sm:col-span-2 flex flex-col gap-2">
//                   <label className="text-base font-bold text-blue-800">Invoice Subject <span className="text-blue-700">*</span></label>
//                   <input className="border-2 border-blue-300 rounded-lg px-4 py-3 text-base text-blue-900 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition font-semibold" value={subject} placeholder="eg. Subject to Pune Jurisdiction" onChange={e => setSubject(e.target.value)} />
//                   <div className="text-xs text-blue-500 pt-1">This will appear on your LR/Invoice preview.</div>
//                 </div>
//                 <div className="sm:col-span-2 flex gap-2 items-center mt-4">
//                   <label className="font-bold text-blue-800">Consignment Date:</label>
//                   <input type="date" className="border-2 border-blue-300 rounded-lg px-2 py-1 font-bold bg-white text-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500 transition" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} max={new Date().toISOString().slice(0, 10)} />
//                 </div>
//               </div>
//             )}

//             {/* STEP 5: Items */}
//             {step === 5 && (
//               <div className="space-y-6">
//                 <p className="text-lg font-extrabold text-blue-900">Add items to this consignment</p>
//                 {items.map((item, idx) => {
//                   const rowTotal = itemTotal(item);
//                   return (
//                     <div key={idx} className="border-2 border-blue-200 bg-white rounded-2xl p-6 space-y-4 shadow-lg">
//                       <div className="flex items-center justify-between">
//                         <span className="text-base font-bold text-blue-900 uppercase tracking-wide">Item {idx + 1}</span>
//                         {idx > 0 && (
//                           <button type="button" onClick={() => setItems(p => p.filter((_, i) => i !== idx))} className="text-base text-red-600 hover:text-white hover:bg-red-600 px-3 py-1 rounded-lg border-2 border-red-600 font-bold tracking-wider transition">Remove</button>
//                         )}
//                       </div>
//                       <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
//                         <div className="col-span-2 md:col-span-4 flex flex-col gap-1.5">
//                           <label className="text-sm text-blue-900 font-bold">Item Name *</label>
//                           <input className="border-2 border-blue-300 rounded-lg px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-blue-500 font-semibold" placeholder="e.g. Wheat, Cotton, Rice" value={item.name} onChange={e => updateItem(idx, "name", e.target.value)} />
//                         </div>
//                         <div className="flex flex-col gap-1.5">
//                           <label className="text-sm text-blue-900 font-bold">Qty <span className="text-blue-400 font-normal">(Qtl)</span></label>
//                           <input type="number" min={0} className="border-2 border-blue-300 rounded-lg px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-blue-500 font-semibold" placeholder="0" value={item.qty} onChange={e => updateItem(idx, "qty", e.target.value)} />
//                         </div>
//                         <div className="flex flex-col gap-1.5">
//                           <label className="text-sm text-blue-900 font-bold">Weight <span className="text-blue-400 font-normal">(Qtl)</span></label>
//                           <input type="number" min={0} className="border-2 border-blue-300 rounded-lg px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-blue-500 font-semibold" placeholder="0" value={item.weight} onChange={e => updateItem(idx, "weight", e.target.value)} />
//                         </div>
//                         <div className="flex flex-col gap-1.5">
//                           <label className="text-sm text-blue-900 font-bold">Rate / Qtl <span className="text-blue-400 font-normal">(₹)</span></label>
//                           <input type="number" min={0} className="border-2 border-blue-300 rounded-lg px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-blue-500 font-semibold" placeholder="₹ 0" value={item.ratePerQtl} onChange={e => updateItem(idx, "ratePerQtl", e.target.value)} />
//                         </div>
//                         <div className="flex flex-col justify-end gap-1.5">
//                           <label className="text-sm text-blue-900 font-bold invisible">Total</label>
//                           <div className={`rounded-lg px-3 py-2 text-base font-bold border-2 ${rowTotal > 0 ? "bg-blue-50 border-blue-300 text-blue-900" : "bg-gray-50 border-gray-200 text-gray-400"}`}>
//                             {rowTotal > 0 ? `₹${rowTotal.toLocaleString("en-IN")}` : "—"}
//                           </div>
//                         </div>
//                       </div>
//                       {parseFloat(item.qty) > 0 && parseFloat(item.ratePerQtl) > 0 && (
//                         <p className="text-xs text-blue-500 text-right">{parseFloat(item.qty)} Qtl × ₹{parseFloat(item.ratePerQtl).toLocaleString("en-IN")} = <span className="font-bold text-blue-700">₹{rowTotal.toLocaleString("en-IN")}</span></p>
//                       )}
//                     </div>
//                   );
//                 })}
//                 <button type="button" onClick={() => setItems(p => [...p, { name: "", qty: "", weight: "", ratePerQtl: "" }])} className="w-full border-2 border-dashed border-blue-400 text-blue-700 bg-blue-50 hover:bg-blue-100 rounded-2xl py-4 text-base font-extrabold transition text-center">+ Add Another Item</button>
//                 {grandTotal > 0 && (
//                   <div className="flex justify-end">
//                     <div className="bg-blue-700 text-white rounded-xl px-6 py-3 text-base font-extrabold">Total Declared Value: ₹{grandTotal.toLocaleString("en-IN")}</div>
//                   </div>
//                 )}
//                 <div className="border-t-2 border-blue-100 pt-5 space-y-3">
//                   <label className="flex items-center gap-3 cursor-pointer w-fit">
//                     <input type="checkbox" checked={hasBroker} onChange={e => { setHasBroker(e.target.checked); if (!e.target.checked) setBrokerPaidBy(null); }} className="w-5 h-5 accent-blue-700 cursor-pointer" />
//                     <span className="text-base font-bold text-blue-900">Is there a broker involved?</span>
//                   </label>
//                   {hasBroker && (
//                     <div className="ml-8 space-y-2">
//                       <p className="text-sm font-semibold text-blue-700">Broker commission paid by:</p>
//                       <div className="flex gap-4">
//                         {(["receiver", "sender"] as const).map((party) => (
//                           <label key={party} className={`flex items-center gap-2 px-5 py-2.5 rounded-xl border-2 text-base font-bold cursor-pointer transition-all ${brokerPaidBy === party ? "bg-blue-700 border-blue-700 text-white" : "bg-white border-blue-200 text-blue-900 hover:border-blue-500"}`}>
//                             <input type="radio" name="brokerPaidBy" value={party} checked={brokerPaidBy === party} onChange={() => setBrokerPaidBy(party)} className="hidden" />
//                             {party.charAt(0).toUpperCase() + party.slice(1)}
//                             {party === "receiver" && receiver?.name && <span className="text-xs font-normal opacity-75 ml-1">({receiver.name})</span>}
//                             {party === "sender" && sender?.name && <span className="text-xs font-normal opacity-75 ml-1">({sender.name})</span>}
//                           </label>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}

//             {/* STEP 6: Payment */}
//             {step === 6 && (
//               <div className="space-y-6 max-w-xl">
//                 <p className="text-lg font-extrabold text-blue-900 mb-3">Select payment mode</p>
//                 {[
//                   { value: "paid", label: "Paid", desc: "Payment already received" },
//                   { value: "to_pay", label: "To Pay", desc: "Receiver pays on delivery" },
//                   { value: "credit", label: "Credit", desc: "Pay later on credit terms" },
//                 ].map(opt => (
//                   <button key={opt.value} type="button" onClick={() => setPaymentType(opt.value)} className={`w-full text-left px-5 py-4 rounded-lg border-2 font-extrabold text-lg transition-all ${paymentType === opt.value ? "border-blue-600 bg-white shadow" : "border-blue-100 bg-blue-50"}`}>
//                     <div className="flex items-center justify-between">
//                       <div>
//                         <p className={`text-base font-extrabold ${paymentType === opt.value ? "text-blue-700" : "text-blue-900"}`}>{opt.label}</p>
//                         <p className={`text-xs ${paymentType === opt.value ? "text-blue-400" : "text-blue-600/80"}`}>{opt.desc}</p>
//                       </div>
//                       {paymentType === opt.value && <span className="w-6 h-6 rounded-full text-blue-700 flex items-center justify-center border-2 border-blue-700 bg-white shadow"><svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg></span>}
//                     </div>
//                   </button>
//                 ))}
//                 <div className="mt-3 flex items-center gap-4 text-blue-700 font-extrabold text-base">
//                   <span>Who is paying?</span>
//                   <label className="flex items-center gap-1 cursor-pointer">
//                     <input type="radio" name="who_pay" checked={paymentPayableConsignor === "sender"} onChange={() => setPaymentPayableConsignor("sender")} className="form-radio text-blue-600" />
//                     Sender {sender?.name && `(${sender.name})`}
//                   </label>
//                   <label className="flex items-center gap-1 cursor-pointer">
//                     <input type="radio" name="who_pay" checked={paymentPayableConsignor === "receiver"} onChange={() => setPaymentPayableConsignor("receiver")} className="form-radio text-blue-600" />
//                     Receiver {receiver?.name && `(${receiver.name})`}
//                   </label>
//                 </div>
//                 <p className="text-sm text-blue-600 pt-2 font-bold">
//                   LR number: <span className="font-mono font-black text-blue-800">{invoiceNumber.trim() || "Will be auto-generated on submission"}</span>
//                 </p>
//                 <div className="pt-3 flex gap-2 items-center">
//                   <label className="font-bold text-blue-700">Payment/Booking Date:</label>
//                   <input type="date" className="border-2 border-blue-300 rounded-lg px-2 py-1 font-bold bg-white text-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500 transition" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} max={new Date().toISOString().slice(0, 10)} />
//                 </div>
//               </div>
//             )}

//             {/* STEP 7: Invoice summary */}
//             {step === 7 && submittedData && (
//               <div className="space-y-6">
//                 <div className="flex items-center gap-4 bg-blue-50 border-2 border-blue-200 rounded-2xl px-7 py-6">
//                   <span className="text-3xl text-green-600">✓</span>
//                   <div>
//                     <p className="font-extrabold text-blue-900 text-xl">Consignment Created!</p>
//                     <p className="text-lg text-blue-800">LR Number: <span className="font-mono font-black text-blue-700 text-xl">{submittedData.invoiceId}</span></p>
//                   </div>
//                 </div>
//                 <div className="border-2 border-blue-200 rounded-2xl overflow-hidden text-base font-bold">
//                   <div className="bg-blue-100 px-7 py-3 border-b-2 border-blue-200 flex justify-between">
//                     <span className="font-extrabold text-blue-800 tracking-wider">Invoice Summary</span>
//                     <span className="text-blue-800">{selectedDate}</span>
//                   </div>
//                   {[
//                     { label: "Transporter", value: `${submittedData.singletransporter?.company_name}` },
//                     { label: "Driver", value: selectedDriver?.name },
//                     { label: "Vehicle", value: selectedVehicle?.registration_number || selectedVehicle?.vehicle_number },
//                     { label: "Company", value: submittedData.company?.company_name },
//                     { label: "Sender", value: `${submittedData.sender?.name} (${submittedData.sender?.city})` },
//                     { label: "Receiver", value: `${submittedData.receiver?.name} (${submittedData.receiver?.city})` },
//                     { label: "Route", value: `${submittedData.consignmentDetails.origin} → ${submittedData.consignmentDetails.destination}` },
//                     { label: "Items", value: submittedData.items.filter((i: any) => i.name).map((i: any) => i.name).join(", ") },
//                     { label: "Subject", value: (submittedData.subject || subject) },
//                     { label: "EWAY BILL/LR NO.", value: submittedData.ewaybillno },
//                     { label: "Payment", value: submittedData.paymentType === "paid" ? "Paid" : submittedData.paymentType === "to_pay" ? "To Pay" : "Credit" },
//                     { label: "Pay By", value: submittedData.paymentPayableConsignorId === submittedData.sender?.id ? `Sender (${submittedData.sender?.name})` : submittedData.paymentPayableConsignorId === submittedData.receiver?.id ? `Receiver (${submittedData.receiver?.name})` : "—" },
//                     { label: "Date", value: selectedDate },
//                     // ✅ Show broker info in summary if applicable
//                     ...(hasBroker ? [{ label: "Broker Paid By", value: brokerPaidBy === "sender" ? `Sender (${sender?.name})` : brokerPaidBy === "receiver" ? `Receiver (${receiver?.name})` : "—" }] : []),
//                   ].map(row => (
//                     <div key={row.label} className="flex px-7 py-4 border-b border-blue-100/80 last:border-0 bg-white">
//                       <span className="text-blue-400 w-32 shrink-0">{row.label}</span>
//                       <span className="text-blue-900 font-bold">{row.value || "—"}</span>
//                     </div>
//                   ))}
//                 </div>
//                 <div className="flex gap-4">
//                   <button type="button" onClick={handleNewConsignment} className="flex-1 border-2 border-blue-600 rounded-xl py-3 text-base font-bold text-blue-700 hover:bg-blue-100 transition">New Consignment</button>
//                   <button type="button" className="flex-1 bg-blue-700 hover:bg-white text-white hover:text-blue-700 rounded-xl py-3 text-base font-extrabold transition border-2 border-blue-700" onClick={() => setShowInvoiceModal(true)}>View/Download Invoice PDF</button>
//                 </div>
//               </div>
//             )}

//             {/* Navigation */}
//             {step < 7 && (
//               <div className="border-t-2 border-[#456bcb] px-10 py-6 flex justify-between items-center bg-gradient-to-r from-[#ddeaff] to-[#f3f7fe] font-extrabold mt-2 flex-col gap-3 sm:flex-row sm:gap-0 sm:justify-between sm:items-center">
//                 <button type="button" onClick={() => setStep(s => s - 1)} disabled={step === 0} className="px-7 py-3 bg-white rounded-xl border-2 border-blue-400 text-base font-bold text-blue-700 hover:bg-blue-50 hover:text-blue-900 disabled:opacity-50 disabled:cursor-not-allowed transition shadow-sm">Back</button>
//                 <button type="button" onClick={handleNext} disabled={!isStepValid()} className={`px-10 py-3 rounded-xl text-base font-extrabold transition tracking-wider shadow ${step === steps.length - 2 ? "bg-blue-700 hover:bg-white text-white hover:text-blue-700 border-2 border-blue-700" : "bg-white hover:bg-blue-700 text-blue-700 hover:text-white border-2 border-blue-700"} disabled:opacity-50 disabled:cursor-not-allowed`}>{step === steps.length - 2 ? "Generate Invoice" : "Next →"}</button>
//               </div>
//             )}

//             {/* Invoice Modal */}
//             {showInvoiceModal && (
//               <div className="fixed z-50 inset-0 flex items-center justify-center bg-blue-900/30 backdrop-blur-md transition-all">
//                 <div className="bg-white rounded-xl shadow-2xl border-4 border-blue-700 max-w-2xl w-full relative flex flex-col items-stretch sm:max-w-2xl sm:min-w-[360px] sm:mx-2 mx-2 min-w-0" style={{ maxHeight: "95vh" }}>
//                   <button className="absolute top-3 right-3 bg-blue-700 text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-blue-800 transition" onClick={() => setShowInvoiceModal(false)}>✕</button>
//                   <div className="pt-8 pb-4 px-2 sm:px-6 w-full">
//                     <h2 className="text-lg font-bold text-blue-700 text-center mb-2">Invoice Preview</h2>
//                     <div className="w-full" style={{ maxHeight: 400, overflowY: "auto", border: "1px solid #c9d5f8", background: "#fff", margin: "0 auto" }}>
//                       <div ref={previewPanelRef} style={{ padding: 8, background: "#fff", width: "100%", minWidth: 0, maxWidth: "794px", margin: "0 auto", boxSizing: "border-box" }} className="overflow-x-auto">
//                         <div className="inline-block" style={{ width: "100%", minWidth: "320px", maxWidth: "794px" }}>
//                           <InvoicePreviewPanel company={company} sender={sender} receiver={receiver} selectedDate={selectedDate} transporter={singletransporter} selectedTransport={selectedTransporterMock} selectedDriver={selectedDriver} selectedVehicle={selectedVehicle} consignmentDetails={consignmentDetails} items={items} paymentType={paymentType} step={7} submittedData={submittedData} subject={subject} invoiceNumber={invoiceNumber} />
//                         </div>
//                       </div>
//                     </div>
//                     <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:gap-4 justify-center w-full">
//                       <button className="bg-blue-700 text-white px-4 py-2 sm:px-6 sm:py-2 rounded-lg font-bold border-2 border-blue-700 hover:bg-white hover:text-blue-700 transition w-full sm:w-auto" onClick={handleDownloadPdf}>Download PDF</button>
//                       <button className="bg-blue-400 text-white px-4 py-2 sm:px-6 sm:py-2 rounded-lg font-bold border-2 border-blue-500 hover:bg-white hover:text-blue-600 transition w-full sm:w-auto" onClick={handleSharePdf}>Share</button>
//                       <a className="bg-green-600 text-white px-4 py-2 sm:px-6 sm:py-2 rounded-lg font-bold border-2 border-green-700 hover:bg-white hover:text-green-700 hover:underline transition w-full sm:w-auto text-center" href={pdfUrl || "#"} target="_blank" rel="noopener noreferrer" download={`invoice_${submittedData?.invoiceId}.pdf`}>Open PDF Link</a>
//                     </div>
//                   </div>
//                   {showShareOptions && (
//                     <div className="mt-4 border-t pt-4 px-2 sm:px-6">
//                       <div className="mb-2 text-sm font-bold text-blue-700">Share invoice:</div>
//                       <input className="border px-2 py-1 w-full rounded text-xs bg-blue-50 text-blue-900" value={pdfUrl || ""} readOnly onFocus={e => e.target.select()} />
//                       <div className="flex flex-col sm:flex-row gap-2 mt-2">
//                         <button className="bg-blue-700 text-white px-4 py-2 rounded font-bold text-xs w-full sm:w-auto" onClick={() => { if (pdfUrl) { navigator.clipboard.writeText(pdfUrl); alert("Copied to clipboard."); } }}>Copy Link</button>
//                         <button className="px-2 py-2 text-xs text-red-500 underline w-full sm:w-auto" onClick={() => setShowShareOptions(false)}>Close</button>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}

//           </div>
//         </div>

//         {/* Live preview panel */}
//         <div className="lg:flex flex-col mb-[20px] md:mb-0 md:m-6 w-[100%] md:w-[42%] shrink-0 border-l-2 border-[#456bcb] bg-gradient-to-b from-white to-[#dce7fb] px-6 py-6 overflow-y-auto shadow-inner rounded-tr-2xl rounded-br-2xl">
//           <div style={{ position: "relative" }}>
//             <div ref={previewPanelRef} style={{ width: "100%", maxWidth: "100%", minWidth: "100%", background: "#fff", boxSizing: "border-box" }}>
//               <InvoicePreviewPanel company={company} sender={sender} receiver={receiver} transporter={singletransporter} selectedTransport={selectedTransporterMock} selectedDriver={selectedDriver} selectedVehicle={selectedVehicle} consignmentDetails={consignmentDetails} selectedDate={selectedDate} items={items} paymentType={paymentType} step={step} submittedData={submittedData} subject={subject} invoiceNumber={invoiceNumber} />
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default AddConsignment;
import React, { useState, useRef, useEffect, useCallback } from "react";
import axios from "axios";
import { Document, Page, Text, View, StyleSheet, Image, pdf } from '@react-pdf/renderer';

// ─── Types ───────────────────────────────────────────────────────────────────
interface Company { id: number; company_name: string; address: string | null; password: string; pancard: string; city: string | null; state: string | null; country: string | null; gst_number: string | null; gst_uin: string | null; code: string | null; cin: string | null; email: string | null; created_at: string; updated_at: string; HSN_SAC: string; GST_SLAB: string | null; signature: string; prefix: string; postfix: string; separatorsign: string; }
interface User { id: number; name: string; email: string; number: string; password: string; role: string; deletedUser: number; createdAt: string; updatedAt: string; address: string | null; city: string | null; state: string | null; pincode: string | null; gst_number: string | null; pan_number: string | null; aadhaar_number: string | null; license_number: string | null; bank_name: string | null; bank_account_number: string | null; bank_ifsc: string | null; account_holder_name: string | null; }
interface Vehicle { id: number; vehicle_number: string; transporter_id?: number | null; driver_id: number; registration_number: string; vehicle_type: string | null; capacity_kg: number; }
interface Driver { id: number; name: string; phone: string; license_number: string; license_expiry: string; }
interface Transporter { id: number; company_name: string; }
interface Item { name: string; qty: string; weight: string; ratePerQtl: string; }
interface Note { id: string; text: string; color: string; }

// ─── Helpers ─────────────────────────────────────────────────────────────────
function fmtDate(iso: string) {
  if (!iso) return "";
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(-2);
  return `${dd}/${mm}/${yy}`;
}

function numberToWords(num: number): string {
  if (!num || num === 0) return '';
  const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const g = ['', 'Thousand', 'Lakh', 'Crore'];
  function toW(n: number): string {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
    if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + toW(n % 100) : '');
    const chunks: number[] = [];
    chunks.push(n % 1000); let nn = Math.floor(n / 1000);
    while (nn > 0) { chunks.push(nn % 100); nn = Math.floor(nn / 100); }
    let res = '';
    for (let i = chunks.length - 1; i >= 0; i--)
      if (chunks[i]) res += (res ? ' ' : '') + toW(chunks[i]) + (g[i] ? ' ' + g[i] : '');
    return res.trim();
  }
  const parts = num.toFixed(2).split('.');
  let str = toW(parseInt(parts[0]));
  if (parseInt(parts[1]) > 0) str += ' and ' + toW(parseInt(parts[1])) + ' Paise';
  return str.toUpperCase() + ' ONLY /-';
}

function generateInvoiceId(origin: string, destination: string, vehicle_number: string | undefined, dateString: string) {
  return (origin?.substring(0, 2) || "OR").toUpperCase() +
    (destination?.substring(0, 2) || "DE").toUpperCase() +
    (vehicle_number ? vehicle_number.slice(-4) : "0000") +
    dateString.replace(/-/g, "");
}

// ─── Inline Field Dropdown ────────────────────────────────────────────────────
interface FieldDropdownProps<T> {
  label: string; value: T | null; options: T[]; getLabel: (item: T) => string;
  getSub?: (item: T) => string; onSelect: (item: T) => void; onAdd: () => void;
  placeholder?: string; className?: string;
}
function FieldDropdown<T extends { id: number }>({ label, value, options, getLabel, getSub, onSelect, onAdd, placeholder = "Click to select", className = "" }: FieldDropdownProps<T>) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const h = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, []);
  const filtered = options.filter(o => getLabel(o).toLowerCase().includes(search.toLowerCase()) || (getSub?.(o) || "").toLowerCase().includes(search.toLowerCase()));
  return (
    <div ref={ref} className={`relative inline-block ${className}`}>
      <button type="button" onClick={() => { setOpen(v => !v); setSearch(""); }}
        className="group flex items-center gap-1 border-b border-dashed border-blue-400 hover:border-blue-700 transition-colors min-w-[80px] text-left">
        {value ? <span className="font-black text-black text-xs leading-tight">{getLabel(value)}</span>
          : <span className="text-blue-400 italic text-[10px]">{placeholder}</span>}
        <svg className="w-3 h-3 text-blue-400 ml-1 shrink-0" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9" /></svg>
      </button>
      {open && (
        <div className="absolute z-50 top-full left-0 mt-1 w-64 bg-white border-2 border-blue-400 rounded-lg shadow-xl overflow-hidden">
          <div className="p-2 border-b border-blue-100">
            <input autoFocus className="w-full text-xs px-2 py-1.5 border border-blue-200 rounded focus:outline-none focus:border-blue-500"
              placeholder={`Search ${label}...`} value={search} onChange={e => setSearch(e.target.value)} />
          </div>
          <div className="max-h-48 overflow-y-auto">
            {filtered.map(o => (
              <button key={o.id} type="button" onClick={() => { onSelect(o); setOpen(false); }}
                className={`w-full text-left px-3 py-2 hover:bg-blue-50 transition-colors ${value?.id === o.id ? "bg-blue-50 font-bold" : ""}`}>
                <div className="text-xs font-semibold text-gray-900">{getLabel(o)}</div>
                {getSub && <div className="text-[10px] text-gray-500">{getSub(o)}</div>}
              </button>
            ))}
            {filtered.length === 0 && <div className="px-3 py-2 text-[10px] text-gray-400 italic">No results found</div>}
          </div>
          <div className="border-t border-blue-100 p-1.5">
            <button type="button" onClick={() => { setOpen(false); onAdd(); }}
              className="w-full flex items-center gap-1.5 px-3 py-2 text-xs font-bold text-blue-700 hover:bg-blue-50 rounded transition-colors">
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              Add new {label}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Inline Text Field ───────────────────────────────────────────────────────
function InlineEdit({ value, onChange, placeholder, className = "", type = "text", small = false }: {
  value: string; onChange: (v: string) => void; placeholder?: string; className?: string; type?: string; small?: boolean;
}) {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => { if (editing) inputRef.current?.focus(); }, [editing]);
  return editing ? (
    <input ref={inputRef} type={type}
      className={`border-b-2 border-blue-500 outline-none bg-transparent font-bold ${small ? "text-[10px] w-24" : "text-xs w-32"} ${className}`}
      value={value} onChange={e => onChange(e.target.value)} onBlur={() => setEditing(false)}
      onKeyDown={e => e.key === "Enter" && setEditing(false)} placeholder={placeholder} />
  ) : (
    <span onClick={() => setEditing(true)}
      className={`cursor-text border-b border-dashed border-blue-400 hover:border-blue-700 transition-colors ${small ? "text-[10px]" : "text-xs"} font-bold ${!value ? "text-blue-400 italic font-normal" : "text-black"} ${className}`}>
      {value || placeholder || "click to edit"}
    </span>
  );
}

// ─── Add Modal ───────────────────────────────────────────────────────────────
function AddModal({ title, fields, onClose, onSave }: {
  title: string; fields: { key: string; label: string; required?: boolean; type?: string }[];
  onClose: () => void; onSave: (data: Record<string, string>) => Promise<void>;
}) {
  const [form, setForm] = useState<Record<string, string>>({});
  const [saving, setSaving] = useState(false);
  const handleSave = async () => {
    setSaving(true);
    try { await onSave(form); onClose(); } catch { } finally { setSaving(false); }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl border-2 border-blue-400 w-full max-w-md mx-4">
        <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100">
          <h3 className="font-black text-blue-900 text-base">Add {title}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          </button>
        </div>
        <div className="px-6 py-4 space-y-3">
          {fields.map(f => (
            <div key={f.key}>
              <label className="text-xs font-bold text-gray-600 block mb-1">{f.label}{f.required && <span className="text-red-500 ml-0.5">*</span>}</label>
              <input type={f.type || "text"} className="w-full border-2 border-blue-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-500 transition-colors"
                value={form[f.key] || ""} onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))} placeholder={f.label} />
            </div>
          ))}
        </div>
        <div className="flex gap-3 px-6 pb-5">
          <button onClick={onClose} className="flex-1 py-2.5 border-2 border-gray-200 rounded-xl text-sm font-bold text-gray-600 hover:border-gray-400 transition-colors">Cancel</button>
          <button onClick={handleSave} disabled={saving} className="flex-1 py-2.5 bg-blue-700 hover:bg-blue-800 text-white rounded-xl text-sm font-bold transition-colors disabled:opacity-50">
            {saving ? "Saving…" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Note System ─────────────────────────────────────────────────────────────
const NOTE_COLORS = [
  { bg: "bg-yellow-100 border-yellow-400", dot: "bg-yellow-400", label: "Yellow" },
  { bg: "bg-blue-100 border-blue-400", dot: "bg-blue-400", label: "Blue" },
  { bg: "bg-red-100 border-red-400", dot: "bg-red-400", label: "Red" },
  { bg: "bg-green-100 border-green-400", dot: "bg-green-400", label: "Green" },
];

function NotesPanel({ notes, setNotes }: { notes: Note[]; setNotes: React.Dispatch<React.SetStateAction<Note[]>> }) {
  const [adding, setAdding] = useState(false);
  const [newText, setNewText] = useState("");
  const [newColor, setNewColor] = useState(0);
  return (
    <div className="border-t-2 border-dashed border-amber-300 bg-amber-50/60">
      <div className="flex items-center justify-between px-3 py-1.5">
        <span className="text-[9px] font-black uppercase tracking-widest text-amber-700">📌 Notes</span>
        <button type="button" onClick={() => setAdding(v => !v)}
          className="text-[9px] font-bold text-amber-700 hover:text-amber-900 border border-amber-400 rounded px-2 py-0.5 transition">
          {adding ? "Cancel" : "+ Add Note"}
        </button>
      </div>
      {adding && (
        <div className="px-3 pb-2 flex flex-col gap-1.5">
          <textarea className="w-full text-[10px] border border-amber-300 rounded p-1.5 resize-none bg-white focus:outline-none focus:border-amber-500 h-16"
            placeholder="Type your note here…" value={newText} onChange={e => setNewText(e.target.value)} />
          <div className="flex items-center gap-2">
            <div className="flex gap-1">
              {NOTE_COLORS.map((c, i) => (
                <button key={i} type="button" onClick={() => setNewColor(i)}
                  className={`w-4 h-4 rounded-full border-2 ${c.dot} ${newColor === i ? "border-gray-700 scale-125" : "border-transparent"} transition-all`} />
              ))}
            </div>
            <button type="button" disabled={!newText.trim()}
              onClick={() => {
                if (!newText.trim()) return;
                setNotes(p => [...p, { id: Date.now().toString(), text: newText.trim(), color: NOTE_COLORS[newColor].bg }]);
                setNewText(""); setAdding(false);
              }}
              className="ml-auto text-[9px] font-bold bg-amber-500 text-white rounded px-2 py-0.5 disabled:opacity-50 transition">Save Note</button>
          </div>
        </div>
      )}
      {notes.length > 0 && (
        <div className="px-3 pb-2 flex flex-col gap-1">
          {notes.map(n => (
            <div key={n.id} className={`flex items-start gap-1 border rounded p-1.5 ${n.color}`}>
              <p className="text-[9px] flex-1 leading-tight">{n.text}</p>
              <button type="button" onClick={() => setNotes(p => p.filter(x => x.id !== n.id))}
                className="text-[8px] text-red-500 hover:text-red-700 font-black ml-1 shrink-0">✕</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── PDF Styles ──────────────────────────────────────────────────────────────
const S = StyleSheet.create({
  page: { fontFamily: 'Helvetica', fontSize: 9, color: '#000', backgroundColor: '#fff', padding: '10px' },
  outerBorder: { border: '2px solid black', flex: 1 },
  header: { borderBottom: '2px solid black', paddingVertical: 6, paddingHorizontal: 8, alignItems: 'center', backgroundColor: '#f0f0f0' },
  companyName: { fontSize: 22, fontFamily: 'Helvetica-Bold', letterSpacing: 2, textTransform: 'uppercase' },
  companyTagline: { fontSize: 7, color: '#555', marginTop: 1, letterSpacing: 1 },
  companyAddress: { fontSize: 7.5, marginTop: 2, color: '#333' },
  docTitle: { fontSize: 10, fontFamily: 'Helvetica-Bold', letterSpacing: 3, textTransform: 'uppercase', marginTop: 3, borderTop: '1px solid #ccc', paddingTop: 2 },
  gstRow: { flexDirection: 'row', borderBottom: '1px solid black' },
  gstCell: { flex: 1, paddingHorizontal: 6, paddingVertical: 3, borderRight: '1px solid black' },
  gstLabel: { fontSize: 6.5, color: '#888', textTransform: 'uppercase', marginBottom: 1 },
  gstValue: { fontSize: 8.5, fontFamily: 'Helvetica-Bold' },
  ownersRisk: { paddingHorizontal: 6, paddingVertical: 3, minWidth: 100, alignItems: 'flex-end', justifyContent: 'center' },
  ownersRiskText: { fontSize: 7, color: '#c00', fontFamily: 'Helvetica-Bold' },
  emailRow: { borderBottom: '1px solid black', paddingHorizontal: 6, paddingVertical: 2, flexDirection: 'row', justifyContent: 'space-between' },
  banner: { backgroundColor: '#1a1a2e', borderBottom: '1px solid black', paddingVertical: 3, alignItems: 'center' },
  bannerText: { fontSize: 7, letterSpacing: 2, textTransform: 'uppercase', color: '#fff' },
  lrNumberBox: { backgroundColor: '#e8f4ff', borderBottom: '2px solid black', paddingVertical: 4, paddingHorizontal: 8, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
  lrNumberLabel: { fontSize: 8, fontFamily: 'Helvetica-Bold', color: '#333' },
  lrNumberValue: { fontSize: 14, fontFamily: 'Helvetica-Bold', color: '#003399', letterSpacing: 1 },
  consignBlock: { flexDirection: 'row', borderBottom: '1px solid black' },
  consignLeft: { flex: 1, paddingHorizontal: 6, paddingVertical: 5, borderRight: '1px solid black' },
  consignLabel: { fontSize: 6.5, color: '#888', textTransform: 'uppercase', marginBottom: 2, letterSpacing: 0.5 },
  consignName: { fontSize: 11, fontFamily: 'Helvetica-Bold' },
  consignGst: { fontSize: 7, color: '#555', marginTop: 1 },
  consignAddress: { fontSize: 7.5, color: '#555', marginTop: 2 },
  consignRight: { width: 185, paddingHorizontal: 6, paddingVertical: 5, backgroundColor: '#fafafa' },
  detailRow: { flexDirection: 'row', alignItems: 'center', marginBottom: 3, borderBottom: '1px dotted #ddd', paddingBottom: 2 },
  detailLabel: { fontFamily: 'Helvetica-Bold', fontSize: 7.5, marginRight: 3, color: '#444', width: 60 },
  detailValue: { fontSize: 7.5, color: '#111', flex: 1 },
  noteBox: { width: 185, paddingHorizontal: 8, paddingVertical: 5, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff8f0' },
  noteText: { color: '#cc0000', fontFamily: 'Helvetica-Bold', fontSize: 9, textAlign: 'center', lineHeight: 1.4 },
  brokerBox: { flexDirection: 'row', borderBottom: '1px solid black', backgroundColor: '#fffbeb', paddingHorizontal: 6, paddingVertical: 3 },
  brokerLabel: { fontSize: 7, fontFamily: 'Helvetica-Bold', color: '#92400e', marginRight: 6 },
  brokerValue: { fontSize: 7, color: '#333' },
  table: { width: '100%' },
  tableHeaderRow: { flexDirection: 'row', backgroundColor: '#1a1a2e' },
  tableRow: { flexDirection: 'row' },
  tableAltRow: { flexDirection: 'row', backgroundColor: '#f9f9f9' },
  th: { border: '1px solid #333', paddingHorizontal: 4, paddingVertical: 3, fontFamily: 'Helvetica-Bold', fontSize: 7.5, textAlign: 'center', color: '#fff' },
  td: { border: '1px solid #ccc', paddingHorizontal: 4, paddingVertical: 3, fontSize: 7.5 },
  totalsRow: { flexDirection: 'row', borderTop: '2px solid black' },
  totalsLeft: { flex: 1, borderRight: '1px solid black', paddingHorizontal: 6, paddingVertical: 5 },
  totalsRight: { width: 185, backgroundColor: '#fafafa' },
  totalLineRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 6, paddingVertical: 2, borderBottom: '1px solid #e0e0e0' },
  totalLineBold: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 6, paddingVertical: 4, borderBottom: '2px solid black', backgroundColor: '#1a1a2e' },
  totalLineLight: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 6, paddingVertical: 2, borderBottom: '1px solid #eee' },
  totalLabel: { fontSize: 7.5 },
  totalValue: { fontSize: 7.5, fontFamily: 'Helvetica-Bold' },
  footerRow: { flexDirection: 'row', borderTop: '1px solid black' },
  footerLeft: { flex: 1, borderRight: '1px solid black', paddingHorizontal: 6, paddingVertical: 5 },
  footerRight: { width: 185, paddingHorizontal: 8, paddingVertical: 5, alignItems: 'center' },
  paymentRow: { flexDirection: 'row', borderTop: '1px solid black', paddingHorizontal: 6, paddingVertical: 3, alignItems: 'center', backgroundColor: '#f5f5f5' },
  amountWordsRow: { borderTop: '1px solid black', paddingHorizontal: 6, paddingVertical: 3 },
  notesRow: { borderTop: '1px solid black', paddingHorizontal: 6, paddingVertical: 3, backgroundColor: '#fffdf0' },
  computerNote: { borderTop: '1px solid black', paddingVertical: 3, alignItems: 'center', backgroundColor: '#f0f0f0' },
  bold: { fontFamily: 'Helvetica-Bold' },
  gray: { color: '#666' },
  small: { fontSize: 7 },
  white: { color: '#fff' },
});

// ─── PDF Document ─────────────────────────────────────────────────────────────
function InvoicePDF({ company, sender, receiver, selectedVehicle, origin, destination, items, paymentType, invoiceId, selectedDate, subject, transporter, hasBroker, brokerPaidBy, brokerUser, notes, driver }: any) {
  const safeItems = Array.isArray(items) ? items.filter((i: any) => i?.name) : [];
  const total = safeItems.reduce((sum: number, item: any) => sum + (parseFloat(item.qty) || 0) * (parseFloat(item.ratePerQtl) || 0), 0);
  const paymentLabel = paymentType === 'paid' ? 'PAID' : paymentType === 'to_pay' ? 'TO PAY' : 'CREDIT';
  const colFlex = [0.35, 2.8, 0.9, 0.7, 0.8, 0.9, 1];
  const colHeaders = ['#', 'Product Description', 'HSN Code', 'UOM', 'Qty', 'Rate/Qtl', 'Amount'];
  const displayItems = safeItems.length > 0 ? safeItems : [{}, {}, {}, {}];
  const brokerName = hasBroker ? (brokerPaidBy === 'sender' ? sender?.name : receiver?.name) : null;
  return (
    <Document>
      <Page size="A4" style={S.page}>
        <View style={S.outerBorder}>
          {/* Header */}
          <View style={S.header}>
            <Text style={S.companyName}>{company?.company_name || 'COMPANY NAME'}</Text>
            <Text style={S.companyTagline}>GOODS TRANSPORT AGENCY</Text>
            <Text style={S.companyAddress}>{company?.address || ''}</Text>
            <Text style={S.docTitle}>LORRY RECEIPT (LR)</Text>
          </View>
          {/* GST / PAN */}
          <View style={S.gstRow}>
            <View style={S.gstCell}><Text style={S.gstLabel}>GST Enrol No:</Text><Text style={S.gstValue}>{company?.gst_number || '—'}</Text></View>
            <View style={S.gstCell}><Text style={S.gstLabel}>PAN No.</Text><Text style={S.gstValue}>{company?.pancard || '—'}</Text></View>
            <View style={S.gstCell}><Text style={S.gstLabel}>CIN No.</Text><Text style={S.gstValue}>{company?.cin || '—'}</Text></View>
            <View style={S.ownersRisk}><Text style={S.ownersRiskText}>AT OWNER'S RISK</Text></View>
          </View>
          {/* Email / Phone */}
          <View style={S.emailRow}>
            <Text style={{ fontSize: 7.5 }}>Email: {company?.email || ''}</Text>
            <Text style={{ fontSize: 7.5 }}>Subject to {subject || 'Kishangarh'} Jurisdiction</Text>
          </View>
          {/* LR Number Banner */}
          <View style={S.lrNumberBox}>
            <Text style={S.lrNumberLabel}>LR / GR No.</Text>
            <Text style={S.lrNumberValue}>{invoiceId || '—'}</Text>
            <Text style={S.lrNumberLabel}>Date: {fmtDate(selectedDate)}</Text>
          </View>
          {/* Banner */}
          <View style={S.banner}><Text style={S.bannerText}>LORRY RECEIPT / CONSIGNMENT NOTE</Text></View>
          {/* Consignor */}
          <View style={S.consignBlock}>
            <View style={S.consignLeft}>
              <Text style={S.consignLabel}>Consignor / Supplier Name &amp; Address</Text>
              <Text style={S.consignName}>{sender?.name || '—'}</Text>
              {sender?.gst_number && <Text style={S.consignGst}>GST: {sender.gst_number}</Text>}
              <Text style={S.consignAddress}>{sender?.address || ''}</Text>
              {sender?.number && <Text style={[S.consignAddress, { marginTop: 2 }]}>Ph: {sender.number}</Text>}
            </View>
            <View style={S.consignRight}>
              <View style={S.detailRow}><Text style={S.detailLabel}>{(selectedVehicle?.vehicle_type || 'TRUCK').toUpperCase()}:</Text><Text style={S.detailValue}>{selectedVehicle?.vehicle_number || '—'}</Text></View>
              <View style={S.detailRow}><Text style={S.detailLabel}>FROM:</Text><Text style={S.detailValue}>{origin || '—'}</Text></View>
              <View style={S.detailRow}><Text style={S.detailLabel}>TO:</Text><Text style={S.detailValue}>{destination || '—'}</Text></View>
              <View style={S.detailRow}><Text style={S.detailLabel}>TRANSPORTER:</Text><Text style={S.detailValue}>{selectedVehicle?.vehicle_number || '—'}</Text></View>
            </View>
          </View>
          {/* Consignee */}
          <View style={S.consignBlock}>
            <View style={S.consignLeft}>
              <Text style={S.consignLabel}>Consignee / Recipient Name &amp; Address</Text>
              <Text style={S.consignName}>{receiver?.name || '—'}</Text>
              {receiver?.gst_number && <Text style={S.consignGst}>GST: {receiver.gst_number}</Text>}
              <Text style={S.consignAddress}>{receiver?.address || ''}</Text>
              {receiver?.number && <Text style={[S.consignAddress, { marginTop: 2 }]}>Ph: {receiver.number}</Text>}
            </View>
            <View style={S.noteBox}>
              <Text style={S.noteText}>NOTE —{'\n'}NO CASH{'\n'}ONLY CHEQUE OR POD</Text>
            </View>
          </View>
          {/* Items Table */}
          <View style={S.table}>
            <View style={S.tableHeaderRow}>
              {colHeaders.map((h, i) => <View key={h} style={[S.th, { flex: colFlex[i] }]}><Text>{h}</Text></View>)}
            </View>
            {displayItems.map((item: any, i: number) => {
              const qty = parseFloat(item.qty) || 0; const rate = parseFloat(item.ratePerQtl) || 0; const amount = qty * rate;
              return (
                <View key={i} style={i % 2 === 0 ? S.tableRow : S.tableAltRow}>
                  <View style={[S.td, { flex: colFlex[0], textAlign: 'center' }]}><Text>{item.name ? String(i + 1) : ''}</Text></View>
                  <View style={[S.td, { flex: colFlex[1] }]}><Text>{item.name || ''}</Text></View>
                  <View style={[S.td, { flex: colFlex[2], textAlign: 'center' }]}><Text>{item.name ? '—' : ''}</Text></View>
                  <View style={[S.td, { flex: colFlex[3], textAlign: 'center' }]}><Text>{item.name ? 'Qtl' : ''}</Text></View>
                  <View style={[S.td, { flex: colFlex[4], textAlign: 'right' }]}><Text>{item.qty || ''}</Text></View>
                  <View style={[S.td, { flex: colFlex[5], textAlign: 'right' }]}>
                    <Text>{rate > 0 ? `₹${parseFloat(rate.toString()).toLocaleString('en-IN')}` : ''}</Text>
                  </View>
                  <View style={[S.td, { flex: colFlex[6], textAlign: 'right' }]}>
                    <Text>{amount > 0 ? `₹${amount.toLocaleString('en-IN')}` : ''}</Text>
                  </View>
             
                </View>
              );
            })}
          </View>
          {/* Totals */}
          <View style={S.totalsRow}>
            <View style={S.totalsLeft}>
              <Text style={[S.bold, { fontSize: 8, marginBottom: 3 }]}>GST WILL BE PAID BY CONSIGNEE</Text>
              <Text style={[S.bold, { fontSize: 7.5, marginBottom: 2 }]}>BANK: {sender?.bank_name || '—'}</Text>
              <Text style={{ fontSize: 7.5 }}>A/C: {sender?.bank_account_number || '—'} | IFSC: {sender?.bank_ifsc || '—'}</Text>
            </View>
            <View style={S.totalsRight}>
              <View style={S.totalLineRow}><Text style={S.totalLabel}>SUB TOTAL</Text><Text style={S.totalValue}>{total > 0 ? `₹${total.toLocaleString('en-IN')}` : ''}</Text></View>
              <View style={S.totalLineRow}><Text style={S.totalLabel}>ROUND OFF</Text><Text style={S.totalValue}></Text></View>
              <View style={S.totalLineBold}><Text style={[S.totalLabel, S.bold, S.white]}>GRAND TOTAL</Text><Text style={[S.totalValue, S.bold, S.white]}>{total > 0 ? `₹${total.toLocaleString('en-IN')}` : ''}</Text></View>
              <View style={S.totalLineLight}><Text style={S.totalLabel}>INVOICE NO.:</Text><Text style={S.totalValue}>{invoiceId || ''}</Text></View>
              <View style={S.totalLineLight}><Text style={S.totalLabel}>INVOICE VALUE:</Text><Text style={S.totalValue}></Text></View>
              <View style={S.totalLineLight}><Text style={S.totalLabel}>DELIVERY AT:</Text><Text style={S.totalValue}>{destination || ''}</Text></View>
              <View style={S.totalLineLight}><Text style={S.totalLabel}>EWAY BILL NO.:</Text><Text style={S.totalValue}></Text></View>
            </View>
          </View>
          {/* Footer */}
          <View style={S.footerRow}>
            <View style={S.footerLeft}>
              <Text style={[S.bold, { fontSize: 7.5, marginBottom: 2 }]}>TERMS &amp; CONDITIONS:</Text>
              <Text style={[S.gray, { fontSize: 7 }]}>1. Carrier not responsible for leakage, breakage, or water damage.</Text>
              <Text style={[S.gray, { fontSize: 7 }]}>2. Goods booked at owner's risk unless otherwise stated.</Text>
              <Text style={[S.gray, { fontSize: 7 }]}>3. Claims must be notified within 24 hours of delivery.</Text>
              <Text style={[S.bold, { fontSize: 7.5, marginTop: 4 }]}>E. &amp; O.E.</Text>
            </View>
            <View style={S.footerRight}>
              {company?.signature ? <Image src={`${process.env.REACT_APP_API_URL}${company.signature}`} style={{ maxHeight: 36, objectFit: 'contain', marginBottom: 4 }} /> : <View style={{ height: 36 }} />}
              <Text style={[S.bold, { fontSize: 7.5, textAlign: 'center' }]}>For {company?.company_name || 'COMPANY'}</Text>
              <Text style={[{ fontSize: 7, textAlign: 'center', marginTop: 2, color: '#555' }]}>Authorised Signatory</Text>
            </View>
          </View>
          {/* Driver + Notes 2-column row */}
          <View style={{ flexDirection: 'row', borderTop: '1px solid black' }}>
            {/* Left: Driver details */}
            <View style={{ flex: 1, borderRight: '1px solid black', paddingHorizontal: 6, paddingVertical: 4 }}>
              <Text style={[S.bold, { fontSize: 7.5, marginBottom: 3, borderBottom: '1px solid #ddd', paddingBottom: 2 }]}>DRIVER DETAILS</Text>
              <View style={S.detailRow}>
                <Text style={S.detailLabel}>NAME:</Text>
                <Text style={S.detailValue}>{driver?.name || '—'}</Text>
              </View>
              <View style={S.detailRow}>
                <Text style={S.detailLabel}>PHONE:</Text>
                <Text style={S.detailValue}>{driver?.phone || '—'}</Text>
              </View>
             
              <View style={{ marginTop: 8 }}>
                <Text style={{ fontSize: 7, color: '#888' }}>Driver Signature:</Text>
                <View style={{ borderBottom: '1px solid #333', marginTop: 14, marginHorizontal: 4 }} />
              </View>
            </View>
            {/* Right: Notes */}
            <View style={{ flex: 1, paddingHorizontal: 6, paddingVertical: 4, backgroundColor: '#fffdf0' }}>
              <Text style={[S.bold, { fontSize: 7.5, marginBottom: 3, borderBottom: '1px solid #ddd', paddingBottom: 2 }]}>REMARKS / NOTES</Text>
              {notes && notes.length > 0
                ? notes.map((n: any, i: number) => (
                    <Text key={i} style={{ fontSize: 7, color: '#333', marginBottom: 2 }}>• {n.text}</Text>
                  ))
                : <Text style={{ fontSize: 7, color: '#bbb', fontStyle: 'italic' }}>No remarks</Text>
              }
            </View>
          </View>
          {/* Payment */}
          <View style={S.paymentRow}>
            <Text style={[S.bold, { fontSize: 8 }]}>PAYMENT MODE: </Text>
            {['PAID', 'TO PAY', 'CREDIT'].map(pt => (
              <Text key={pt} style={[S.bold, { fontSize: 8, marginLeft: 6, paddingHorizontal: 8, paddingVertical: 2, backgroundColor: paymentLabel === pt ? '#1a1a2e' : '#fff', color: paymentLabel === pt ? '#fff' : '#000', border: '1px solid #333' }]}>{pt}</Text>
            ))}
          </View>
          {/* Amount in Words */}
          <View style={S.amountWordsRow}>
            <Text style={{ fontSize: 7.5 }}><Text style={S.bold}>AMOUNT IN WORDS: </Text><Text style={[S.gray, { fontStyle: 'italic' }]}>{total > 0 ? numberToWords(total) : ''}</Text></Text>
          </View>
          {/* Footer note */}
          <View style={S.computerNote}><Text style={[S.gray, S.small]}>THIS IS A COMPUTER GENERATED LR AND DOES NOT REQUIRE A SIGNATURE.</Text></View>
        </View>
      </Page>
    </Document>
  );
}

// ─── Real Invoice Preview ─────────────────────────────────────────────────────
function InvoicePreview({ company, sender, receiver, vehicle, driver, origin, destination, items, paymentType, paymentPaidBy, invoiceNumber, selectedDate, subject, transporter, hasBroker, brokerPaidBy, notes, setNotes, setCompany, setModal, setSender, users, vehicles, setVehicle, setDriver, drivers, setReceiver, updateItem, setItems, setInvoiceNumber, setOrigin, setDestination, setSubject, setPaymentType, setPaymentPaidBy, companies }: any) {

  const grandTotal = items.reduce((acc: number, it: Item) => acc + (parseFloat(it.qty) || 0) * (parseFloat(it.ratePerQtl) || 0), 0);
  const displayLrNo = invoiceNumber.trim() || (origin && destination && vehicle
    ? generateInvoiceId(origin, destination, vehicle.vehicle_number, selectedDate)
    : "LR-AUTO");

  // ADDED: Responsive styling/classes for root and major flex layouts
  return (
    <div
      className="
        bg-white border-2 border-gray-900 shadow-2xl font-sans text-[10px] rounded-sm overflow-hidden
        w-full
        max-w-full
        sm:max-w-[500px]
        md:max-w-[650px]
        lg:max-w-[75vw]
        mx-auto
        "
      style={{
        // To allow smooth scaling on mobile; font-size via tailwind still, but width/overflow handled here.
        boxSizing: "border-box"
      }}
    >

      {/* Company Header */}
      <div className="text-center bg-gray-100 border-b-2 border-black py-3 px-2 sm:px-4">
        <div className="text-[8px] text-blue-500 font-bold uppercase tracking-widest mb-1 opacity-60">↓ Click to change company</div>
        <FieldDropdown<any>
          label="Company" value={company} options={companies}
          getLabel={(c: any) => c.company_name}
          getSub={(c: any) => `${c.city || ""} · GST: ${c.gst_number || ""}`}
          onSelect={setCompany} onAdd={() => setModal("company")} placeholder="SELECT COMPANY"
          className="mx-auto"
        />
        {company && <>
          <p className="text-[7px] uppercase tracking-widest text-gray-500 mt-0.5">Goods Transport Agency</p>
          <p className="text-[8px] mt-0.5 text-gray-600">{company.address}</p>
          <div className="mt-1 text-[8px] font-black tracking-[3px] border-t border-gray-300 pt-1 text-gray-700">LORRY RECEIPT (LR)</div>
        </>}
      </div>

      {/* GST / PAN / CIN */}
      <div className="flex flex-col sm:flex-row border-b border-black text-[9px]">
        <div className="flex-1 px-2 py-1.5 border-b sm:border-b-0 sm:border-r border-black">
          <span className="text-[7px] text-gray-400 uppercase block">GST Enrol No.</span>
          <span className="font-bold">{company?.gst_number || <span className="text-gray-300">—</span>}</span>
        </div>
        <div className="flex-1 px-2 py-1.5 border-b sm:border-b-0 sm:border-r border-black">
          <span className="text-[7px] text-gray-400 uppercase block">PAN No.</span>
          <span className="font-bold">{company?.pancard || <span className="text-gray-300">—</span>}</span>
        </div>
        <div className="flex-1 px-2 py-1.5 border-b sm:border-b-0 sm:border-r border-black">
          <span className="text-[7px] text-gray-400 uppercase block">CIN No.</span>
          <span className="font-bold">{company?.cin || <span className="text-gray-300">—</span>}</span>
        </div>
        <div className="px-2 py-1.5 flex items-center justify-end min-w-[90px]">
          <span className="text-[7px] text-red-600 font-bold">AT OWNER'S RISK</span>
        </div>
      </div>

      {/* Email / Subject */}
      <div className="px-2 py-1 text-[8px] border-b border-black flex flex-col sm:flex-row justify-between sm:items-center gap-1">
        <span>Email: {company?.email || <span className="text-gray-300">—</span>}</span>
        <span className="italic text-gray-500">
          Subject to&nbsp;
          <InlineEdit value={subject} onChange={setSubject} placeholder="Kishangarh" className="text-[8px]" small />
          &nbsp;Jurisdiction
        </span>
      </div>

      {/* LR Number Banner */}
      <div className="bg-blue-50 border-b-2 border-black px-2 sm:px-3 py-1.5 flex flex-col sm:flex-row justify-between items-center gap-y-2">
        <div>
          <span className="text-[7px] text-gray-500 uppercase block">LR / GR No.</span>
          <span className="text-sm font-black text-blue-900 tracking-widest">
            <InlineEdit value={invoiceNumber} onChange={setInvoiceNumber} placeholder={displayLrNo} className="text-sm font-black text-blue-900 tracking-widest" />
          </span>
        </div>
        <div className="text-left sm:text-right">
          <span className="text-[7px] text-gray-500 uppercase block">Date</span>
          <span className="font-bold text-gray-900">{fmtDate(selectedDate)}</span>
        </div>
      </div>

      {/* Dark Banner */}
      <div className="bg-[#1a1a2e] text-center py-1.5 border-b border-black">
        <span className="text-[7px] tracking-[3px] uppercase text-white font-bold">LORRY RECEIPT / CONSIGNMENT NOTE</span>
      </div>

      {/* Consignor + Details */}
      <div className="flex flex-col md:flex-row border-b border-black">
        <div className="flex-1 px-2 py-2 border-b md:border-b-0 md:border-r border-black">
          <div className="text-[7px] text-gray-400 uppercase tracking-wide mb-1">Consignor / Supplier Name &amp; Address</div>
          <FieldDropdown<any> label="Sender" value={sender} options={users}
            getLabel={(u: any) => u.name} getSub={(u: any) => `${u.number} · ${u.address || ""}`}
            onSelect={setSender} onAdd={() => setModal("sender")} placeholder="Select Sender" />
          {sender && <>
            {sender.gst_number && <div className="text-[8px] text-gray-500 mt-0.5">GST: {sender.gst_number}</div>}
            <div className="text-[8px] text-gray-500 mt-0.5">{sender.address}</div>
            <div className="text-[8px] text-gray-500">Ph: {sender.number}</div>
          </>}
        </div>
        <div className="w-full md:w-52 px-2 py-2 text-[9px] space-y-1 bg-gray-50">
          {[
            { label: "VEHICLE:", content: <FieldDropdown<any> label="Vehicle" value={vehicle} options={vehicles} getLabel={(v: any) => v.vehicle_number || v.registration_number} getSub={(v: any) => v.vehicle_type || ""} onSelect={setVehicle} onAdd={() => setModal("vehicle")} placeholder="Select" /> },
            { label: "FROM:", content: <InlineEdit value={origin} onChange={setOrigin} placeholder="origin city" small /> },
            { label: "TO:", content: <InlineEdit value={destination} onChange={setDestination} placeholder="destination city" small /> },
            { label: "DRIVER:", content: <FieldDropdown<any> label="Driver" value={driver} options={drivers} getLabel={(d: any) => d.name} getSub={(d: any) => d.phone} onSelect={setDriver} onAdd={() => setModal("driver")} placeholder="Select" /> },
            { label: "TRANSPORTER:", content: <span className="font-bold text-black text-[9px]">{vehicle?.vehicle_number || <span className="text-gray-300 italic font-normal">—</span>}</span> },
          ].map(({ label, content }) => (
            <div key={label} className="flex items-center gap-1 border-b border-dotted border-gray-200 pb-1">
              <span className="font-bold text-gray-600 w-20 shrink-0 text-[8px]">{label}</span>
              {content}
            </div>
          ))}
        </div>
      </div>

      {/* Consignee */}
      <div className="flex flex-col md:flex-row border-b border-black">
        <div className="flex-1 px-2 py-2 border-b md:border-b-0 md:border-r border-black">
          <div className="text-[7px] text-gray-400 uppercase tracking-wide mb-1">Consignee / Recipient Name &amp; Address</div>
          <FieldDropdown<any> label="Receiver" value={receiver} options={users}
            getLabel={(u: any) => u.name} getSub={(u: any) => `${u.number} · ${u.address || ""}`}
            onSelect={setReceiver} onAdd={() => setModal("receiver")} placeholder="Select Receiver" />
          {receiver && <>
            {receiver.gst_number && <div className="text-[8px] text-gray-500 mt-0.5">GST: {receiver.gst_number}</div>}
            <div className="text-[8px] text-gray-500 mt-0.5">{receiver.address}</div>
            <div className="text-[8px] text-gray-500">Ph: {receiver.number}</div>
          </>}
        </div>
        <div className="w-full md:w-52 flex items-center justify-center px-2 sm:px-4 py-2 bg-orange-50">
          <p className="text-red-700 font-black text-[10px] text-center leading-snug border border-red-300 rounded p-2 bg-white">NOTE —<br />NO CASH<br />ONLY CHEQUE OR POD</p>
        </div>
      </div>

      {/* Items Table */}
      {/* Table is horizontally scrollable on xs devices. */}
      <div className="w-full overflow-x-auto">
        <table className="w-[700px] min-w-full sm:w-full border-collapse text-[9px]">
          <thead>
            <tr className="bg-[#1a1a2e] text-white">
              <th className="border border-gray-600 px-1 py-1 w-5 text-center">#</th>
              <th className="border border-gray-600 px-2 py-1 text-left">Product Description</th>
              <th className="border border-gray-600 px-1 py-1 w-12">HSN</th>
              <th className="border border-gray-600 px-1 py-1 w-8">UOM</th>
              <th className="border border-gray-600 px-1 py-1 w-14 text-right">Qty</th>
              <th className="border border-gray-600 px-1 py-1 w-16 text-right">Rate/Qtl</th>
              <th className="border border-gray-600 px-1 py-1 w-16 text-right">Amount</th>
              <th className="border border-gray-600 px-1 py-1 w-5"></th>
            </tr>
          </thead>
          <tbody>
            {items.map((item: Item, i: number) => {
              const qty = parseFloat(item.qty) || 0;
              const rate = parseFloat(item.ratePerQtl) || 0;
              const amount = qty * rate;
              return (
                <tr key={i} className={`group ${i % 2 === 1 ? "bg-gray-50" : ""}`}>
                  <td className="border border-gray-200 px-1 py-1 text-center text-[8px] text-gray-400">{i + 1}</td>
                  <td className="border border-gray-200 px-2 py-1">
                    <input className="w-full bg-transparent outline-none border-b border-dashed border-blue-200 focus:border-blue-500 text-[9px] font-semibold placeholder:text-gray-300"
                      placeholder="Item name…" value={item.name} onChange={e => updateItem(i, "name", e.target.value)} />
                  </td>
                  <td className="border border-gray-200 px-1 py-1 text-center text-[8px] text-gray-300">—</td>
                  <td className="border border-gray-200 px-1 py-1 text-center text-[8px]">Qtl</td>
                  <td className="border border-gray-200 px-1 py-1">
                    <input type="number" className="w-full bg-transparent outline-none border-b border-dashed border-blue-200 focus:border-blue-500 text-[9px] font-semibold text-right placeholder:text-gray-300"
                      placeholder="0" value={item.qty} onChange={e => updateItem(i, "qty", e.target.value)} min={0} />
                  </td>
                  <td className="border border-gray-200 px-1 py-1">
                    <input type="number" className="w-full bg-transparent outline-none border-b border-dashed border-blue-200 focus:border-blue-500 text-[9px] font-semibold text-right placeholder:text-gray-300"
                      placeholder="₹0" value={item.ratePerQtl} onChange={e => updateItem(i, "ratePerQtl", e.target.value)} min={0} />
                  </td>
                  <td className="border border-gray-200 px-1 py-1 text-right font-bold text-[9px]">
                    {amount > 0 ? `₹${amount.toLocaleString("en-IN")}` : "—"}
                  </td>
                  <td className="border border-gray-200 px-1 py-1 text-center">
                    {i > 0 && (
                      <button type="button" onClick={() => setItems((p: Item[]) => p.filter((_: Item, j: number) => j !== i))}
                        className="text-red-400 hover:text-red-700 opacity-0 group-hover:opacity-100 transition-opacity text-[10px] font-black">×</button>
                    )}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td colSpan={8} className="border border-gray-200 px-2 py-1">
                <button type="button" onClick={() => setItems((p: Item[]) => [...p, { name: "", qty: "", weight: "", ratePerQtl: "" }])}
                  className="text-blue-600 hover:text-blue-800 text-[8px] font-bold flex items-center gap-1 transition-colors">
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                  Add row
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Totals */}
      <div className="flex flex-col md:flex-row border-t-2 border-black">
        <div className="flex-1 px-2 py-2 border-b md:border-b-0 md:border-r border-black text-[8px]">
          <p className="font-bold text-[9px] mb-1">GST WILL BE PAID BY CONSIGNEE</p>
          <p className="font-bold mb-0.5">BANK: {sender?.bank_name || <span className="font-normal text-gray-400">—</span>}</p>
          <p>A/C: {sender?.bank_account_number || "—"} | IFSC: {sender?.bank_ifsc || "—"}</p>
        </div>
        <div className="w-full md:w-52 text-[9px]">
          {[["SUB TOTAL", grandTotal > 0 ? `₹${grandTotal.toLocaleString("en-IN")}` : ""],
            ["ROUND OFF", ""]].map(([l, v]) => (
              <div key={l} className="flex justify-between px-2 py-1 border-b border-gray-100">
                <span className="text-gray-500">{l}</span><span className="font-bold">{v}</span>
              </div>
            ))}
          <div className="flex justify-between px-2 py-1.5 border-b-2 border-black font-black bg-[#1a1a2e] text-white">
            <span>GRAND TOTAL</span>
            <span>{grandTotal > 0 ? `₹${grandTotal.toLocaleString("en-IN")}` : "—"}</span>
          </div>
          {[["INVOICE NO.:", displayLrNo], ["INVOICE VALUE:", ""], ["DELIVERY AT:", destination], ["EWAY BILL NO.:", ""]].map(([l, v]) => (
            <div key={l} className="flex justify-between px-2 py-1 border-b border-gray-100">
              <span className="text-gray-500 whitespace-nowrap text-[8px]">{l}</span><span className="font-bold">{v}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="flex flex-col md:flex-row border-t border-black">
        <div className="flex-1 px-2 py-2 border-b md:border-b-0 md:border-r border-black text-[8px]">
          <p className="font-bold mb-0.5 text-[9px]">TERMS &amp; CONDITIONS:</p>
          <p className="text-gray-500 leading-relaxed">1. Carrier not responsible for leakage, breakage, or water damage.</p>
          <p className="text-gray-500">2. Goods booked at owner's risk unless otherwise stated.</p>
          <p className="text-gray-500">3. Claims must be notified within 24 hours of delivery.</p>
          <p className="font-bold mt-1 text-[8px]">E. &amp; O.E.</p>
        </div>
        <div className="w-full md:w-52 px-3 py-2 text-center text-[8px]">
          <div className="h-10 flex items-center justify-center mb-1">
            {company?.signature && <img src={`${process.env.REACT_APP_API_URL}${company.signature}`} alt="sig" className="max-h-10 object-contain" />}
          </div>
          <p className="font-bold">For {company?.company_name || "—"}</p>
          <p className="text-gray-500 text-[7px]">Authorised Signatory</p>
        </div>
      </div>

      {/* Driver Details + Notes (2-column, responsive stacked on xs) */}
      <div className="flex flex-col md:flex-row border-t border-black">
        {/* Left: Driver details */}
        <div className="flex-1 px-2 py-2 border-b md:border-b-0 md:border-r border-black text-[8px]">
          <p className="font-bold text-[9px] mb-1.5 pb-1 border-b border-gray-200">DRIVER DETAILS</p>
          {[
            ["Name", driver?.name],
            ["Phone", driver?.phone],
            ["License", driver?.license_number],
          ].map(([lbl, val]) => (
            <div key={lbl} className="flex items-center gap-1 mb-0.5">
              <span className="text-gray-500 w-14 shrink-0">{lbl}:</span>
              <span className="font-bold text-black">{val || <span className="text-gray-300 font-normal">—</span>}</span>
            </div>
          ))}
          <div className="mt-3 pt-1">
            <p className="text-[7px] text-gray-400">Driver Signature:</p>
            <div className="border-b border-dashed border-gray-400 mt-5 mx-1" />
          </div>
        </div>
        {/* Right: Notes */}
        <div className="flex-1">
          <NotesPanel notes={notes} setNotes={setNotes} />
        </div>
      </div>

      {/* Payment Mode */}
      <div className="flex flex-col sm:flex-row border-t border-black items-center px-2 py-1.5 gap-2 md:gap-4 bg-gray-50">
        <span className="font-bold text-[9px]">PAYMENT:</span>
        <div className="flex gap-2">
          {["paid", "to_pay", "credit"].map(pt => (
            <button key={pt} type="button" onClick={() => setPaymentType(pt)}
              className={`px-2 py-0.5 text-[8px] font-bold border rounded transition-all ${paymentType === pt ? "bg-[#1a1a2e] text-white border-[#1a1a2e]" : "border-gray-400 text-gray-600 hover:border-gray-800"}`}>
              {pt === "paid" ? "PAID" : pt === "to_pay" ? "TO PAY" : "CREDIT"}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-2 text-[8px] mt-1 sm:mt-0 ml-0 sm:ml-2 flex-wrap">
          <span className="font-bold text-gray-600">Payable by:</span>
          <label className="flex items-center gap-1 cursor-pointer">
            <input type="radio" checked={paymentPaidBy === "sender"} onChange={() => setPaymentPaidBy("sender")} className="w-3 h-3 accent-blue-700" />
            Sender {sender?.name && `(${sender.name})`}
          </label>
          <label className="flex items-center gap-1 cursor-pointer">
            <input type="radio" checked={paymentPaidBy === "receiver"} onChange={() => setPaymentPaidBy("receiver")} className="w-3 h-3 accent-blue-700" />
            Receiver {receiver?.name && `(${receiver.name})`}
          </label>
        </div>
      </div>

      {/* Amount in Words */}
      <div className="px-2 py-1 border-t border-black text-[8px]">
        <span className="font-bold">AMOUNT IN WORDS: </span>
        <span className="italic text-gray-500">{grandTotal > 0 ? numberToWords(grandTotal) : ""}</span>
      </div>

      {/* Computer Note */}
      <div className="text-center text-[7px] text-gray-400 py-1 border-t border-black bg-gray-50">
        THIS IS A COMPUTER GENERATED LR AND DOES NOT REQUIRE A SIGNATURE.
      </div>
    </div>
  );
}


// Main Component
export const AddConsignment: React.FC = () => {
  // ...state and functions & axios logic unchanged...

  const [companies, setCompanies] = useState<Company[]>([]);
  const [users, setUsers] = useState<User[]>([]);
  const [vehicles, setVehicles] = useState<Vehicle[]>([]);
  const [drivers, setDrivers] = useState<Driver[]>([]);
  const [transporters, setTransporters] = useState<Transporter[]>([]);
  const [company, setCompany] = useState<Company | null>(null);
  const [sender, setSender] = useState<User | null>(null);
  const [receiver, setReceiver] = useState<User | null>(null);
  const [vehicle, setVehicle] = useState<Vehicle | null>(null);
  const [driver, setDriver] = useState<Driver | null>(null);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [selectedDate, setSelectedDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [origin, setOrigin] = useState("");
  const [destination, setDestination] = useState("");
  const [description, setDescription] = useState("");
  const [subject, setSubject] = useState("Kishangarh");
  const [items, setItems] = useState<Item[]>([{ name: "", qty: "", weight: "", ratePerQtl: "" }]);
  const [paymentType, setPaymentType] = useState("paid");
  const [paymentPaidBy, setPaymentPaidBy] = useState<"sender" | "receiver">("sender");
  const [hasBroker, setHasBroker] = useState(false);
  const [brokerPaidBy, setBrokerPaidBy] = useState<"sender" | "receiver" | null>(null);
  const [notes, setNotes] = useState<Note[]>([]);
  const [modal, setModal] = useState<null | "company" | "sender" | "receiver" | "vehicle" | "driver">(null);
  const [submitting, setSubmitting] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [submittedInvoiceId, setSubmittedInvoiceId] = useState("");
  const [showShareOptions, setShowShareOptions] = useState(false);
  const loadData = useCallback(async () => {
    try {
      const [compRes, userRes, vehRes, drvRes, trRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_URL}/companyAuth/companies`),
        axios.get(`${process.env.REACT_APP_API_URL}/auth/alluser/consignor`),
        axios.get(`${process.env.REACT_APP_API_URL}/auth/vehicles`),
        axios.get(`${process.env.REACT_APP_API_URL}/auth/drivers`),
        axios.get(`${process.env.REACT_APP_API_URL}/auth/transporters`),
      ]);
      setCompanies(compRes.data || []);
      setUsers(userRes.data || []);
      setVehicles(vehRes.data || []);
      setDrivers(drvRes.data || []);
      setTransporters(trRes.data || []);
    } catch (e) { console.error(e); }
  }, []);
  useEffect(() => { loadData(); }, [loadData]);

  const updateItem = (idx: number, key: keyof Item, value: string) =>
    setItems(prev => prev.map((it, i) => i === idx ? { ...it, [key]: value } : it));
  const grandTotal = items.reduce((acc, it) => acc + (parseFloat(it.qty) || 0) * (parseFloat(it.ratePerQtl) || 0), 0);
  const displayLrNo = invoiceNumber.trim() || (origin && destination && vehicle
    ? generateInvoiceId(origin, destination, vehicle.vehicle_number, selectedDate)
    : "");

  // Submit
  async function handleSubmit() {
    if (!company || !sender || !receiver || !vehicle || !driver || !origin || !destination || !items[0]?.name) {
      alert("Please fill all required fields: company, sender, receiver, vehicle, driver, origin, destination, and at least one item.");
      return;
    }
    setSubmitting(true);
    try {
      const invoiceId = invoiceNumber.trim() || generateInvoiceId(origin, destination, vehicle.vehicle_number, selectedDate);
      const transporter = transporters.find(t => t.id === (vehicle as any).transporter_id) || null;

      const blob = await pdf(
        <InvoicePDF company={company} sender={sender} receiver={receiver} selectedVehicle={vehicle}
          origin={origin} destination={destination} items={items} paymentType={paymentType}
          invoiceId={invoiceId} selectedDate={selectedDate} subject={subject} transporter={transporter}
          hasBroker={hasBroker} brokerPaidBy={brokerPaidBy} notes={notes} driver={driver}/>
      ).toBlob();
      const formData = new FormData();
      formData.append("invoicePdf", blob, `invoice_${invoiceId}.pdf`);
      formData.append("invoiceId", invoiceId);
      const uploadResp = await axios.post(`${process.env.REACT_APP_API_URL}/invoiceapi/uploadpdf`, formData, { headers: { "Content-Type": "multipart/form-data" } });
      const link = uploadResp.data?.link ? `${process.env.REACT_APP_API_URL}${uploadResp.data.link}` : "";
      if (link) setPdfUrl(link);

      const itemIds: number[] = [];
      for (const item of items) {
        if (!item.name) continue;
        const computedAmount = (parseFloat(item.qty) || 0) * (parseFloat(item.ratePerQtl) || 0);
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/invoiceapi/invoice_items`, {
          invoiceId, description: item.name, hsm_code: "-", uom: "Qtl", qty: item.qty, amount: computedAmount.toString()
        });
        if (res.data?.insertId) itemIds.push(res.data.insertId);
      }

      const brokerUserId = hasBroker
        ? (brokerPaidBy === "sender" ? sender.id : receiver.id)
        : null;

      await axios.post(`${process.env.REACT_APP_API_URL}/invoiceapi/invoice`, {
        company: company.id, sender: sender.id, receiver: receiver.id,
        payment: `₹${grandTotal.toLocaleString("en-IN")}`,
        transporter: transporter?.id || null,
        driver: driver.id, vehicles: vehicle.id,
        source: origin, destination,
        description, receiverAmountStatatus: "Pending", senderAmountStatatus: "Pending",
        transporterAmountStatatus: "Pending", subjects: subject,
        InvoiceNo: invoiceId, EWAYBILLNO: invoiceId,
        paymentType, paymentPayableConsignor: paymentPaidBy === "sender" ? sender.id : receiver.id,
        date: selectedDate, subject, paymentStatus: paymentType,
        ItemsDescription: JSON.stringify(itemIds), link,
        broker: brokerUserId,
        broker_paid_by: hasBroker ? brokerPaidBy : null,
      });

      setSubmittedInvoiceId(invoiceId);
      setShowSuccess(true);
    } catch (e) {
      alert("Failed to submit: " + (e as any)?.message);
    } finally {
      setSubmitting(false);
    }
  }

  function handleNew() {
    setCompany(null); setSender(null); setReceiver(null); setVehicle(null); setDriver(null);
    setInvoiceNumber(""); setOrigin(""); setDestination(""); setDescription(""); setSubject("Kishangarh");
    setItems([{ name: "", qty: "", weight: "", ratePerQtl: "" }]);
    setPaymentType("paid"); setPaymentPaidBy("sender");
    setPdfUrl(null); setShowSuccess(false); setSubmittedInvoiceId(""); setShowShareOptions(false);
    setSelectedDate(new Date().toISOString().slice(0, 10));
    setHasBroker(false); setBrokerPaidBy(null); setNotes([]);
  }

  async function handleAddCompany(data: Record<string, string>) {
    await axios.post(`${process.env.REACT_APP_API_URL}/companyAuth/company`, {
      company_name: data.company_name, address: data.address, pancard: data.pancard,
      gst_number: data.gst_number, email: data.email, password: data.password || "password123",
      HSN_SAC: "", prefix: "", postfix: "", separatorsign: ""
    });
    await loadData();
  }

  async function handleAddUser(data: Record<string, string>, role: string) {
    await axios.post(`${process.env.REACT_APP_API_URL}/auth/admin/users`, {
      name: data.name, email: data.email, number: data.number, password: data.password || "password123",
      role, address: data.address
    });
    await loadData();
  }

  async function handleAddVehicle(data: Record<string, string>) {
    await axios.post(`${process.env.REACT_APP_API_URL}/auth/vehicles`, {
      vehicle_number: data.vehicle_number, registration_number: data.vehicle_number,
      vehicle_type: data.vehicle_type || "Truck", capacity_kg: 1000,
      transporter_id: null, driver_id: null
    });
    await loadData();
  }

  async function handleAddDriver(data: Record<string, string>) {
    await axios.post(`${process.env.REACT_APP_API_URL}/auth/drivers`, {
      name: data.name, phone: data.phone, license_number: data.license_number || "N/A",
      license_expiry: "2030-01-01", user_id: 1, transporter_id: null
    });
    await loadData();
  }

  const transporter = vehicle ? transporters.find(t => t.id === (vehicle as any).transporter_id) || null : null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-blue-50 to-indigo-100 p-2 md:p-6 lg:p-8">
      <div className="max-w-full md:max-w-3xl lg:max-w-5xl mx-auto mb-[80px] md:mb-[60px]">
 
        {/* Header */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 gap-2">
          <div>
            <h1 className="text-2xl font-black text-slate-900 tracking-tight">New Consignment</h1>
            <p className="text-[13px] sm:text-sm text-slate-500 mt-0.5">Click any field on the LR to edit it directly</p>
          </div>
          <div className="flex items-center gap-3 w-full sm:w-auto">
            <div className="flex items-center gap-2 bg-white border-2 border-blue-200 rounded-xl px-2 sm:px-3 py-2 w-full sm:w-auto">
              <label className="text-xs font-bold text-slate-600">Date:</label>
              <input
                type="date"
                className="text-xs font-bold text-blue-900 bg-transparent focus:outline-none w-full sm:w-auto"
                value={selectedDate}
                onChange={e => setSelectedDate(e.target.value)}
                max={new Date().toISOString().slice(0, 10)}
              />
            </div>
          </div>
        </div>

        {/* ── Broker Toggle (above invoice) ── */}
        <div className="bg-white rounded-2xl border-2 border-amber-200 px-3 sm:px-5 py-2 sm:py-3 mb-4 flex flex-col md:flex-row flex-wrap items-start md:items-center gap-2 md:gap-4">
          <span className="text-sm font-black text-amber-800">🤝 Broker Involved?</span>
          <label className="flex items-center gap-2 cursor-pointer">
            <div
              onClick={() => { setHasBroker(v => !v); if (hasBroker) setBrokerPaidBy(null); }}
              className={`w-11 h-6 rounded-full relative transition-all ${hasBroker ? "bg-amber-500" : "bg-gray-200"}`}>
              <div className={`absolute top-0.5 w-5 h-5 rounded-full bg-white shadow transition-all ${hasBroker ? "left-5" : "left-0.5"}`} />
            </div>
            <span className="text-sm font-bold text-gray-700">{hasBroker ? "Yes" : "No"}</span>
          </label>
          {hasBroker && (
            <div className="flex flex-wrap items-center gap-2 sm:gap-3 ml-0 md:ml-2">
              <span className="text-sm font-bold text-gray-600">Commission paid by:</span>
              {(["sender", "receiver"] as const).map(party => (
                <label key={party}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-xl border-2 text-sm font-bold cursor-pointer transition-all ${brokerPaidBy === party ? "bg-amber-500 border-amber-500 text-white" : "bg-white border-amber-200 text-gray-700 hover:border-amber-400"}`}>
                  <input type="radio" name="brokerPaidBy" value={party} checked={brokerPaidBy === party} onChange={() => setBrokerPaidBy(party)} className="hidden" />
                  {party.charAt(0).toUpperCase() + party.slice(1)}
                  {party === "sender" && sender?.name && <span className="opacity-70 text-xs font-normal">({sender.name})</span>}
                  {party === "receiver" && receiver?.name && <span className="opacity-70 text-xs font-normal">({receiver.name})</span>}
                </label>
              ))}
            </div>
          )}
        </div>

        {/* ── Invoice ── */}
        <div
          className="
            w-full
            sm:max-w-[500px]
            md:max-w-[650px]
            lg:max-w-[75vw]
            mx-auto
            overflow-x-auto
          "
          style={{ zoom: 1.45, minWidth: 0 }}>
          <InvoicePreview
            company={company} setCompany={setCompany} companies={companies}
            sender={sender} setSender={setSender}
            receiver={receiver} setReceiver={setReceiver}
            vehicle={vehicle} setVehicle={setVehicle}
            driver={driver} setDriver={setDriver}
            users={users} vehicles={vehicles} drivers={drivers}
            origin={origin} setOrigin={setOrigin}
            destination={destination} setDestination={setDestination}
            subject={subject} setSubject={setSubject}
            invoiceNumber={invoiceNumber} setInvoiceNumber={setInvoiceNumber}
            selectedDate={selectedDate}
            items={items} setItems={setItems} updateItem={updateItem}
            paymentType={paymentType} setPaymentType={setPaymentType}
            paymentPaidBy={paymentPaidBy} setPaymentPaidBy={setPaymentPaidBy}
            transporter={transporter}
            hasBroker={hasBroker} brokerPaidBy={brokerPaidBy}
            notes={notes} setNotes={setNotes}
            setModal={setModal}
          />
        </div>

        {/* Description / Internal Note */}
        <div className="mt-4 bg-white rounded-2xl border-2 border-blue-200 px-3 sm:px-5 py-2 sm:py-3">
          <label className="text-xs font-bold text-slate-600 block mb-1">Internal Description <span className="font-normal text-slate-400">(not printed on LR)</span></label>
          <textarea className="w-full border border-blue-100 rounded-lg px-3 py-2 text-sm text-slate-700 focus:outline-none focus:border-blue-400 resize-none bg-blue-50" rows={2}
            placeholder="Optional internal notes about this consignment…" value={description} onChange={e => setDescription(e.target.value)} />
        </div>

        {/* Submit Buttons */}
        <div className="mt-6 flex flex-col sm:flex-row justify-end gap-3">
          <button type="button" onClick={handleNew}
            className="px-6 py-3 border-2 border-slate-300 rounded-xl text-sm font-bold text-slate-600 hover:border-slate-500 transition-colors w-full sm:w-auto">
            Reset
          </button>
          <button type="button" onClick={handleSubmit} disabled={submitting}
            className="px-10 py-3 bg-[#1a1a2e] hover:bg-[#2d2d4e] text-white rounded-xl text-sm font-extrabold transition-colors shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 w-full sm:w-auto justify-center">
            {submitting && <svg className="w-4 h-4 animate-spin" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" strokeOpacity={0.25} /><path d="M12 2a10 10 0 0 1 10 10" /></svg>}
            {submitting ? "Generating…" : "Generate LR Invoice →"}
          </button>
        </div>
      </div>

      {/* Success Modal */}
      {showSuccess && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-2">
          <div className="bg-white rounded-2xl shadow-2xl border-2 border-green-400 w-full max-w-md sm:max-w-lg mx-2 p-6 sm:p-8 text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
            </div>
            <h2 className="text-xl font-black text-gray-900 mb-1">LR Invoice Generated!</h2>
            <p className="text-sm text-gray-500 mb-2">LR Number:</p>
            <p className="font-mono font-black text-blue-700 text-lg mb-6">{submittedInvoiceId}</p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button onClick={() => pdfUrl && window.open(pdfUrl, "_blank")}
                className="flex-1 py-3 bg-[#1a1a2e] hover:bg-[#2d2d4e] text-white rounded-xl font-bold text-sm transition-colors">
                Download PDF
              </button>
              <button onClick={() => { if (pdfUrl && navigator.share) navigator.share({ title: "LR Invoice", url: pdfUrl }); else setShowShareOptions(true); }}
                className="flex-1 py-3 border-2 border-blue-300 rounded-xl font-bold text-sm text-blue-700 hover:bg-blue-50 transition-colors">
                Share
              </button>
              <button onClick={handleNew}
                className="flex-1 py-3 border-2 border-gray-200 rounded-xl font-bold text-sm text-gray-600 hover:border-gray-400 transition-colors">
                New
              </button>
            </div>
            {showShareOptions && pdfUrl && (
              <div className="mt-4 border-t pt-4">
                <p className="text-xs font-bold text-blue-700 mb-2">Share link:</p>
                <input className="w-full border px-2 py-1.5 rounded text-xs bg-blue-50" value={pdfUrl} readOnly onFocus={e => e.target.select()} />
                <button className="mt-2 text-xs text-blue-700 font-bold" onClick={() => { navigator.clipboard.writeText(pdfUrl); }}>Copy to clipboard</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modals */}
      {modal === "company" && (
        <AddModal title="Company"
          fields={[{ key: "company_name", label: "Company Name", required: true }, { key: "address", label: "Address" }, { key: "email", label: "Email" }, { key: "pancard", label: "PAN Card" }, { key: "gst_number", label: "GST Number" }]}
          onClose={() => setModal(null)} onSave={handleAddCompany} />
      )}
      {modal === "sender" && (
        <AddModal title="Sender (Consignor)"
          fields={[{ key: "name", label: "Full Name", required: true }, { key: "number", label: "Phone Number", required: true }, { key: "email", label: "Email", required: true }, { key: "address", label: "Address" }]}
          onClose={() => setModal(null)} onSave={d => handleAddUser(d, "consignor")} />
      )}
      {modal === "receiver" && (
        <AddModal title="Receiver (Consignee)"
          fields={[{ key: "name", label: "Full Name", required: true }, { key: "number", label: "Phone Number", required: true }, { key: "email", label: "Email", required: true }, { key: "address", label: "Address" }]}
          onClose={() => setModal(null)} onSave={d => handleAddUser(d, "consignor")} />
      )}
      {modal === "vehicle" && (
        <AddModal title="Vehicle"
          fields={[{ key: "vehicle_number", label: "Vehicle Number", required: true }, { key: "vehicle_type", label: "Vehicle Type (Truck/Tempo etc.)" }]}
          onClose={() => setModal(null)} onSave={handleAddVehicle} />
      )}
      {modal === "driver" && (
        <AddModal title="Driver"
          fields={[{ key: "name", label: "Driver Name", required: true }, { key: "phone", label: "Phone Number", required: true }, { key: "license_number", label: "License Number" }]}
          onClose={() => setModal(null)} onSave={handleAddDriver} />
      )}
    </div>
  );
};

export default AddConsignment;